<template>
  <div class="comp">
    <div class="compContent" v-if="this.staticInfo">
      <div class="title">
        <div class="titleL">
          病例信息
          <span style="
              font-size: 12px;
              color: rgb(245, 136, 42);
              padding-left: 5px;
              font-weight: 600;
            ">日期：{{ $public.FTime(staticInfo.caseDate, "MM-DD") }}</span>
          <span style="
              font-size: 12px;
              color: rgb(245, 136, 42);
              padding-left: 5px;
              font-weight: 600;
            ">病例号：{{ staticInfo.caseNumber }}</span>
          <span style="font-size: 12px; padding-left: 5px; font-weight: 600"
            v-if="guahaoDetail.status === 3">已结束诊疗</span>
        </div>
        <div class="titleR">
          <div class="btnItem" @click="dialogPrintRreview_state = true">
            <img class="btnImg" src="../../../../assets/img/yiliaoxin/bingliBtn1.png" />
            <div class="btnText">打印</div>
          </div>
          <!-- <div class="btnItem">
						<img class="btnImg" src="../../../../assets/img/yiliaoxin/bingliBtn2.png"/>
						<div class="btnText">库存</div>
					</div> -->
          <div class="btnItem" @click="
      dialogBingliChecked_state = true;
    changeIllnessCase('defaultSave');
    ">
            <img class="btnImg" src="../../../../assets/img/yiliaoxin/bingliBtn3.png" />
            <div class="btnText">检测报告</div>
          </div>
          <!-- <div class="btnItem" @click="dialogCopy_state = true">
            <img
              class="btnImg"
              src="../../../../assets/img/yiliaoxin/bingliBtn4.png"
            />
            <div class="btnText">复制病例</div>
          </div> -->
          <!-- <div v-if="!onlySee()" class="btnItem" @click="paste">
            <img
              class="btnImg"
              src="../../../../assets/img/yiliaoxin/bingliBtn5.png"
            />
            <div class="btnText">粘贴病例</div>
          </div> -->
          <div v-if="!onlySee()" class="btnItem" @click="changeIllnessCase('saveBtn')">
            <img class="btnImg" src="../../../../assets/img/yiliaoxin/bingliBtn6.png" />
            <div class="btnText">保存病例</div>
          </div>
          <div v-if="!onlySee() && guahaoDetail.status !== 3" class="btnItem" @click="stopBingli">
            <img class="btnImg" src="../../../../assets/img/yiliaoxin/stopBingli.png" />
            <div class="btnText">结束诊疗</div>
          </div>
          <el-button type="warning" plain size="small" @click="back" style="vertical-align: top">返回</el-button>
        </div>
      </div>
      <div class="content">
        <div class="L" ref="bingliL">
          <!-- 病例记录 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">病情记录</div>
              <div class="boxTitR"></div>
            </div>
            <div class="boxCon">
              <div class="line">
                <div class="label">
                  体格检查
                </div>
                <div class="value">
                  <div class="label1">
                  体重
                  </div>
                  <el-input class="value1" type="number" v-model="form.weight" @input="changeTextNum"
                    :disabled="onlySee()" clearable size="small">
                    <template slot="append">千克</template>
                  </el-input>
                  <div class="label1">
                   体温
                  </div>
                  <el-input class="value1" v-model="form.animalHeat" @input="changeTextNum" :disabled="onlySee()"
                    clearable size="small">
                    <template slot="append">摄氏度</template>
                  </el-input>
                  <br />
                  <div class="label1">
                    呼吸
                  </div>
                  <el-input class="value1" v-model="form.breatheRate" @input="changeTextNum" :disabled="onlySee()"
                    clearable size="small">
                    <template slot="append">次/分</template>
                  </el-input>
                  <div class="label1">
                  心率
                  </div>
                  <el-input class="value1" v-model="form.heartRate" @input="changeTextNum" :disabled="onlySee()"
                    clearable size="small">
                    <template slot="append">次/分</template>
                  </el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">
                 科室
                </div>
                <div class="value">
                  <el-select style="width: 240px" v-model="form.departmentId" :disabled="onlySee()" filterable
                    placeholder="请选择" size="small">
                    <el-option v-for="item in departmentList" :key="item._id" :label="item.name"
                      :value="item._id"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="line">
                <div class="label">
                 主诉
                </div>
                <div class="value">
                  <el-input v-model="form.mainContent" :rows="3" type="textarea" :disabled="onlySee()"></el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">
              临床检查
                </div>
                <div class="value">
                  <el-input v-model="form.clinecContent" :rows="3" type="textarea" :disabled="onlySee()"></el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">
                 病情诊断
                </div>
                <div class="value">
                  <el-cascader v-model="curTag" :options="tagTree" filterable style="width: 350px" :props="{
      children: 'symptom',
      value: 'key',
      label: 'value',
      multiple: true,
      expandTrigger: 'hover',
    }" @change="changeTagTree" :disabled="onlySee()" size="small" popper-class="bingliCascader"></el-cascader>
                </div>
              </div>
              <div class="line">
                <div class="label">
                 诊断说明
                </div>
                <div class="value">
                  <el-input v-model="form.diagnosis" :rows="3" type="textarea" :disabled="onlySee()"
                    placeholder="请输入诊断说明" style="margin-top: 10px"></el-input>
                </div>
              </div>
              <!-- <div class="line">
								<div class="label"><i style="color: #F56C6C;margin-right: 4px;">*</i>病情等级</div>
								<div class="value">
									<el-radio-group v-model="form.conditionLevel" :disabled="onlySee()" style="padding-top:8px;">
										<el-radio :label="1">一般</el-radio>
										<el-radio :label="2">急诊</el-radio>
										<el-radio :label="3">危重</el-radio>
										<el-radio :label="4">频危</el-radio>
									</el-radio-group>
								</div>
							</div> -->
              <div class="line">
                <div class="label">添加照片</div>
                <div class="value">
                  <div v-if="onlySee()">
                    <div v-if="!$public.isNull(staticInfo.imagePath)">
                      <img :src="staticInfo.imagePath[0]" style="width: 50px; height: 50px; cursor: pointer"
                        @click="openWindiw(staticInfo.imagePath[0])" />
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="$public.isNull(staticInfo.imagePath)" style="
                        background-color: #f9fbff;
                        font-size: 12px;
                        color: #5e7bfa;
                        width: 110px;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 4px;
                        cursor: pointer;
                      " @click="upload('petImg', '')">
                      宠物照片
                    </div>
                    <div v-else>
                      <img :src="staticInfo.imagePath[0]" style="width: 50px; height: 50px; cursor: pointer"
                        @click="openWindiw(staticInfo.imagePath[0])" />
                      <div style="
                          background-color: #f9fbff;
                          font-size: 12px;
                          color: #5e7bfa;
                          width: 110px;
                          text-align: center;
                          line-height: 30px;
                          border-radius: 4px;
                          cursor: pointer;
                          display: inline-block;
                          margin-left: 20px;
                          vertical-align: text-bottom;
                        " @click="upload('petImg', '')">
                        重新上传
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 检测 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">检测</div>
              <div class="boxTitR">
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="dialogAddGoods1_state = true">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.inspectItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr1[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column label="名称" min-width="200" prop="goodsName">

                </el-table-column>
                <el-table-column label="出库量" min-width="250" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.skuValue }}
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeNum(props.row)" style="width: 60px" size="small">
                    </el-input>
                    <span v-if="props.row.goodsType === 1">{{
      props.row.unit || "--"
    }}</span>
                    <span v-if="props.row.goodsType === 4">次</span>
                    <span v-if="props.row.goodsType === 1">
                      <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.goodsDosage" @input="changeDosage(props.row)" style="width: 60px" size="small">
                      </el-input>
                      {{ props.row.outUnit || "--" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" min-width="120" prop="goodsName">
                  <template slot-scope="props">
                    <span v-if="props.row.allowWholesale === 0">{{ props.row.countPriceDosage }}*{{
      props.row.price
    }}/{{ props.row.countPriceDosage }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price
    }}元</span>
                    <span v-if="props.row.allowWholesale === 1">{{ props.row.num }}*{{ props.row.price }}/{{
      props.row.num }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price
    }}元</span>
                    <!-- {{$public.getSubtotal(props.row)}} -->
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="150" prop="goodsName">
                  <template slot-scope="props">
                    <!-- <el-button type="text" v-if="props.row.isPay" @click="dialogBingliChecked_state=true;changeIllnessCase('defaultSave')" size="mini" style="color:#5E7BFA;">查看</el-button> -->
                    <!-- <el-button type="text" v-if="props.row.isPay&&props.row.filePath&&!onlySee()" @click="upload(props.$index,props.row)" size="mini" style="color:#5E7BFA;">重传</el-button> -->
                    <el-button type="text" v-if="props.row.isPay && !onlySee()" @click="
      dialogBingliChecked_state = true;
    changeIllnessCase('defaultSave');
    " size="mini" style="color: #5e7bfa">上传</el-button>
                    <el-button type="text" v-if="!props.row.orderNum && !onlySee()" @click="delGoodsApi(props.row)"
                      size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney1.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney1.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney1.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney1.total
      }}</span>
                  </span>
                </div>
              </div>
              <div class="line">
                <div class="label">检查分析</div>
                <div class="value">
                  <el-input v-model="form.analyzeContent" :rows="3" :disabled="onlySee()" type="textarea"></el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">处理治疗</div>
                <div class="value">
                  <el-input v-model="form.cureContent" :rows="3" :disabled="onlySee()" type="textarea"></el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- 处方 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">处方</div>
              <div class="boxTitR">
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="drawerAllergyList_state = true">添加过敏</el-button>
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="dialogAddGoods2_state = true">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.recipelItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr2[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column label="名称" min-width="200" prop="goodsName">
                </el-table-column>
                <el-table-column label="出库量" min-width="250" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.skuValue }}
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeNum(props.row)" style="width: 60px" size="small">
                    </el-input>
                    {{ props.row.unit }}
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.goodsDosage" @input="changeDosage(props.row)" style="width: 60px" size="small">
                    </el-input>
                    {{ props.row.outUnit }}
                  </template>
                </el-table-column>
                <el-table-column label="用法" min-width="160" prop="goodsName">
                  <template slot-scope="props">
                    <span v-if="props.row.goodsUsage.length === 5">
                      {{ props.row.goodsUsage[0] }}
                      {{ props.row.goodsUsage[1] }}天{{
      props.row.goodsUsage[2]
    }}次 每次{{ props.row.goodsUsage[3]
                      }}{{ props.row.goodsUsage[4] }}
                    </span>
                    <span v-else>无</span>
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" min-width="110" prop="goodsName">
                  <template slot-scope="props">
                    <span v-if="props.row.allowWholesale === 0">{{ props.row.countPriceDosage }}*{{ props.row.price }}/{{
      props.row.countPriceDosage }}*{{ props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元</span>
                    <span v-if="props.row.allowWholesale === 1">{{ props.row.num }}*{{ props.row.price }}/{{
      props.row.num }}*{{ props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元</span>
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" prop="goodsName">
                  <template slot-scope="props">
                    <el-button v-if="!onlySee()" type="text" @click="
      curRow = props.row;
    dialogYfyl_state = true;
    " size="mini" style="color: #5e7bfa">用法</el-button>
                    <el-button type="text" v-if="!props.row.orderNum && !onlySee()" @click="delGoodsApi(props.row)"
                      size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney2.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney2.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney2.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney2.total
      }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 并发症处方 -->
          <div class="box" ref="complicationDom" v-show="complicationRadio === true">
            <div class="boxTit">
              <div class="boxTitL">并发症处方</div>
              <div class="boxTitR">
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="dialogAddGoods6_state = true">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.complicationItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr6[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="名称" min-width="150" prop="goodsName">
                </el-table-column>
                <el-table-column label="出库量" min-width="250" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.skuValue }}
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeNum(props.row)" style="width: 60px" size="small">
                    </el-input>
                    {{ props.row.unit }}
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.goodsDosage" @input="changeDosage(props.row)" style="width: 60px" size="small">
                    </el-input>
                    {{ props.row.outUnit }}
                  </template>
                </el-table-column>
                <el-table-column label="用法" min-width="160" prop="goodsName">
                  <template slot-scope="props">
                    <span v-if="props.row.goodsUsage.length === 5">
                      {{ props.row.goodsUsage[0] }}
                      {{ props.row.goodsUsage[1] }}天{{
      props.row.goodsUsage[2]
    }}次 每次{{ props.row.goodsUsage[3]
                      }}{{ props.row.goodsUsage[4] }}
                    </span>
                    <span v-else>无</span>
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" min-width="110" prop="goodsName">
                  <template slot-scope="props">
                    <span v-if="props.row.allowWholesale === 0">{{ props.row.countPriceDosage }}*{{
      props.row.price
    }}/{{ props.row.countPriceDosage }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price
    }}元</span>
                    <span v-if="props.row.allowWholesale === 1">{{ props.row.num }}*{{ props.row.price }}/{{
      props.row.num }}*{{ props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元</span>
                    <!-- {{$public.getSubtotal(props.row)}} -->
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" prop="goodsName">
                  <template slot-scope="props">
                    <el-button v-if="!onlySee()" type="text" @click="
      curRow = props.row;
    dialogYfyl_state = true;
    " size="mini" style="color: #5e7bfa">用法</el-button>
                    <el-button type="text" v-if="!props.row.orderNum && !onlySee()" @click="delGoodsApi(props.row)"
                      size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney6.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney6.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney6.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney6.total
      }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 处置 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">处置</div>
              <div class="boxTitR">
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="dialogAddGoods3_state = true">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.handleItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr3[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="名称" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.goodsName }} *
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeGoodsApi(props.row)" style="width: 60px" size="small">
                    </el-input>
                    次
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.num }}*{{ props.row.price }}/{{ props.row.num }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元
                    <!-- {{$public.getSubtotal(props.row)}} -->
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" prop="goodsName" width="220">
                  <template slot-scope="props">
                    {{ props.row.remark }}
                    <!-- <el-input
										:disabled="!$public.isNull(props.row.orderNum)||onlySee()"
										v-model="props.row.remark"
										@input="changeGoodsApi(props.row)"
										style="width:220px;"
										size="small">
										</el-input> -->
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120" prop="goodsName">
                  <template slot-scope="props">
                    <el-button type="text" v-if="!onlySee()" @click="
      curRow = props.row;
    dialogAddRemark_state = true;
    " size="mini">备注</el-button>
                    <el-button type="text" v-if="!props.row.orderNum && !onlySee()" @click="delGoodsApi(props.row)"
                      size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney3.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney3.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney3.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney3.total
      }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 手术 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">手术</div>
              <div class="boxTitR">
                <el-button v-if="!onlySee()" type="text" icon="el-icon-plus" style="padding: 0; color: #5e7bfa"
                  @click="dialogAddGoods4_state = true">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.operationItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr4[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="名称" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.goodsName }} *
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeGoodsApi(props.row)" style="width: 60px" size="small">
                    </el-input>
                    次
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.num }}*{{ props.row.price }}/{{ props.row.num }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元
                    <!-- {{$public.getSubtotal(props.row)}} -->
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" prop="goodsName">
                  <template slot-scope="props">
                    <el-button type="text" v-if="!props.row.orderNum && !onlySee()" @click="delGoodsApi(props.row)"
                      size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney4.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney4.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney4.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney4.total
      }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 住院 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">住院</div>
              <div class="boxTitR">
                <el-button v-if="!staticInfo.inHospitalId && !onlySee()" type="text" icon="el-icon-plus"
                  style="padding: 0; color: #5e7bfa" @click="createZhuyuan">添加</el-button>
              </div>
            </div>
            <div class="boxCon">
              <el-table :data="staticInfo.inHospitalItem" style="width: 100%">
                <el-table-column width="40">
                  <template slot-scope="props">
                    <el-checkbox v-model="selectedArr5[props.$index]" :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " @change="getTotal()"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="名称" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.goodsName }} *
                    <el-input :disabled="!$public.isNull(props.row.orderNum) || onlySee()
      " v-model="props.row.num" @input="changeGoodsApi(props.row)" style="width: 60px" size="small">
                    </el-input>
                    次
                  </template>
                </el-table-column>
                <el-table-column label="标准价/会员价" prop="goodsName">
                  <template slot-scope="props">
                    {{ props.row.num }}*{{ props.row.price }}/{{ props.row.num }}*{{
      props.row.vipPrice > 0 ? props.row.vipPrice : props.row.price }}元
                    <!-- {{$public.getSubtotal(props.row)}} -->
                    <span v-if="props.row.isPay" style="color: #18a44c">付</span>
                    <span v-else>
                      <span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
                      <span v-if="!props.row.orderNum" style="color:red;">未支付</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80"> </el-table-column>
              </el-table>
              <div class="tableMoneyLine">
                <div class="totalL">
                  <span style="margin-right: 40px">
                    已支付：
                    <span style="font-size: 18px; color: #5e7bfa">{{
      tableMoney5.paid
    }}</span>
                  </span>
                  <span style="color: red">
                    未支付：
                    <span style="font-size: 18px; color: #f77e04">{{
        tableMoney5.unpaid
      }}</span>
                  </span>
                </div>
                <div class="totalR">
                  <span>
                    会员价：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney5.vipTotal
      }}</span>
                  </span>
                  <span>
                    总计：
                    <span style="font-size: 18px; color: #333336">{{
        tableMoney5.total
      }}</span>
                  </span>
                </div>
              </div>
            </div>
            <el-button style="margin-top: 0px; margin-bottom: 5px; padding: 0 10px" type="text"
              v-if="staticInfo.inHospitalId" @click="zhuyuanTableState = !zhuyuanTableState">
              住院信息详情<i class="el-icon--right" :class="zhuyuanTableState ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      "></i>
            </el-button>
            <el-table v-if="staticInfo.inHospitalId" v-show="zhuyuanTableState" :data="curPetZhuyuanList"
              style="width: 100%">
              <el-table-column label="住院单号">
                <template slot-scope="props">
                  {{ props.row.id }}
                </template>
              </el-table-column>
              <el-table-column label="经办人" width="70">
                <template slot-scope="props">
                  <div>{{ props.row.handlerName }}</div>
                </template>
              </el-table-column>
              <el-table-column label="开始时间" width="100">
                <template slot-scope="props">
                  <div>
                    {{ $public.FTime(props.row.beginDate, "YYYY-MM-DD") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="截止时间" width="100">
                <template slot-scope="props">
                  <div>
                    {{ $public.FTime(props.row.endDate, "YYYY-MM-DD") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="已住院时长" width="120" prop="caseInHospitalDuration">
              </el-table-column>
              <el-table-column label="住院情况" width="70">
                <template slot-scope="props">
                  <div>{{ props.row.status == 1 ? "住院中" : "" }}</div>
                  <div>{{ props.row.status == 2 ? "已离院" : "" }}</div>
                </template>
              </el-table-column>
              <el-table-column label="支付状态" width="70">
                <template slot-scope="props" v-if="props.row.payInfo">
                  <div>
                    {{ props.row.payInfo.payCount }}/{{
      props.row.payInfo.total
    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="备注" width="60" prop="remark">
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="props">
                  <el-button v-if="props.row.status != 2" type="text" @click="dialogEditZhuyuan_state = true"
                    size="mini">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 病情追踪 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">病情追踪</div>
              <div class="boxTitR"></div>
            </div>
            <div class="boxCon">
              <div class="line">
                <div class="label">
               医嘱
                </div>
                <div class="value">
                  <el-input v-model="form.doctorAdvice" :rows="3" :disabled="onlySee()" type="textarea"></el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">备注</div>
                <div class="value">
                  <el-input v-model="form.remark" :rows="3" :disabled="onlySee()" type="textarea"></el-input>
                </div>
              </div>
              <div class="line huifangLine">
                <div class="label">添加回访</div>
                <div class="value">
                  <el-input class="huifang" v-model="huifangContent" :rows="3" type="textarea"></el-input>
                  <div class="huifangBtn" @click="addHuifang">添加</div>
                  <div class="huifangHistory" v-if="!$public.isNull(huifangHistoryList)">
                    <div class="huifangHistoryRow" style="border-top: 0">
                      <div class="cell" style="width: 130px; padding: 10px 0">
                        回访记录
                      </div>
                      <div class="cell1" style="padding: 10px 0">回访内容</div>
                    </div>
                    <div class="huifangHistoryRow" v-for="(item, index) in huifangHistoryList" :key="index">
                      <div class="cell" style="width: 130px">
                        {{ $public.FTime(item.visitTime) }}
                      </div>
                      <div class="cell1">{{ item.visitContent }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line">
                <div class="label">是否下次回访</div>
                <div class="value">
                  <el-radio-group v-model="nextHuifangRadio" :disabled="onlySee()" style="padding-top: 10px">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="line" v-if="nextHuifangRadio">
                <div class="label">回访时间</div>
                <div class="value">
                  <el-date-picker v-model="visitTime" type="date" :disabled="onlySee()" placeholder="选择日期" size="small">
                  </el-date-picker>
                  <div style="
                      display: inline-block;
                      font-size: 14px;
                      margin: 0 10px;
                      width: 150px;
                      text-align: right;
                    ">
                    距离回访多少天前提醒
                  </div>
                  <el-select v-model="form.visitDays" :disabled="onlySee()" style="width: 220px; margin-right: 40px"
                    size="small">
                    <el-option v-for="item in [
      { label: '0天', value: 0 },
      { label: '1天', value: 1 },
      { label: '2天', value: 2 },
      { label: '3天', value: 3 },
      { label: '4天', value: 4 },
      { label: '5天', value: 5 },
    ]" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="line">
                <div class="label">紧急联系人</div>
                <div class="value">
                  <el-input style="width: 220px" v-model="form.contactName" :disabled="onlySee()" clearable
                    size="small"></el-input>
                  <div style="
                      display: inline-block;
                      font-size: 14px;
                      margin: 0 10px;
                      width: 150px;
                      text-align: right;
                    ">
                    联系电话
                  </div>
                  <el-input style="width: 220px" v-model="form.contactMobile" :disabled="onlySee()" clearable
                    size="small"></el-input>
                </div>
              </div>
              <div class="line">
                <div class="label">复诊时间</div>
                <div class="value">
                  <el-date-picker v-model="againSeeTime" :disabled="onlySee()" type="date" placeholder="选择日期"
                    size="small">
                  </el-date-picker>
                  <div style="
                      display: inline-block;
                      font-size: 14px;
                      margin: 0 10px;
                      width: 150px;
                      text-align: right;
                    ">
                    距离复诊多少天前提醒
                  </div>
                  <el-select v-model="form.againSeeDays" :disabled="onlySee()" style="width: 220px; margin-right: 40px"
                    size="small">
                    <el-option v-for="item in [
      { label: '0天', value: 0 },
      { label: '1天', value: 1 },
      { label: '2天', value: 2 },
      { label: '3天', value: 3 },
      { label: '4天', value: 4 },
      { label: '5天', value: 5 },
    ]" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="line">
                <div class="label">是否有并发症</div>
                <div class="value">
                  <el-radio-group v-model="complicationRadio" :disabled="onlySee()" style="padding-top: 10px">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="line" v-if="complicationRadio">
                <div class="label">
                  <i style="color: #f56c6c; margin-right: 4px">*</i>并发症诊断
                </div>
                <div class="value">
                  <el-cascader v-model="curTag_complication" :options="tagTree" filterable style="width: 350px" :props="{
      children: 'symptom',
      value: 'key',
      label: 'value',
      multiple: true,
      expandTrigger: 'hover',
    }" :disabled="onlySee()" size="small" popper-class="bingliCascader" @change="changeComplication"></el-cascader>
                </div>
              </div>
              <div class="line" v-if="complicationRadio">
                <div class="label">
                 并发症原因
                </div>
                <div class="value">
                  <el-cascader v-model="curTag_complicationCause" :options="getComplicationCauseList()" filterable
                    style="width: 350px" :props="{
      children: 'symptom',
      value: 'key',
      label: 'value',
      multiple: true,
      expandTrigger: 'hover',
    }" :disabled="onlySee()" size="small" popper-class="bingliCascader"
                    @change="changeComplicationCause"></el-cascader>
                </div>
              </div>
              <div class="line" v-if="complicationRadio">
                <div class="label"></div>
                <div class="value" @click="scrollToComplicationDom">
                  <div style="
                      background-color: rgba(255, 249, 243, 1);
                      border: 1px solid #ffa60e;
                      border-radius: 6px;
                      width: 520px;
                      height: 38px;
                      font-size: 12px;
                      color: #f77e04;
                      text-align: center;
                      box-sizing: border-box;
                      padding-top: 11px;
                      cursor: pointer;
                    ">
                    去开并发症处方
                    <img src="../../../../assets/img/yiliaoxin/pageBack.png" style="vertical-align: text-bottom" />
                  </div>
                </div>
              </div>
              <div class="line">
                <div class="label">康复情况</div>
                <div class="value">
                  <el-radio-group v-model="form.completeState" :disabled="onlySee()" @change="changeCompleteState"
                    style="padding-top: 8px" size="small">
                    <!-- <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
											<el-radio :label="1">治愈中</el-radio>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
											<el-radio :label="2">已治愈</el-radio>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
											<el-radio :label="3">死亡</el-radio>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
											<el-radio :label="4">其它</el-radio>
										</el-tooltip> -->
                    <el-radio :label="1">治愈中</el-radio>
                    <el-radio :label="2">已治愈</el-radio>
                    <el-radio :label="3">死亡</el-radio>
                    <el-radio :label="4">其它</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="line" v-if="staticInfo.completeState === 3">
                <div class="label">死亡原因</div>
                <div class="value">
                  <el-select v-model="staticInfo.diedCause" disabled style="width: 220px; margin-right: 40px"
                    size="small">
                    <el-option v-for="item in [
      { label: '请选择', value: 0 },
      { label: '治愈中死亡', value: 1 },
      { label: '治愈前已处于濒死状态', value: 2 },
    ]" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="line" v-if="staticInfo.completeState === 3">
                <div class="label">死因描述</div>
                <div class="value">
                  <el-input v-model="staticInfo.diedRemark" :rows="3" disabled type="textarea"></el-input>
                </div>
              </div>
              <div class="line" v-if="staticInfo.completeState === 4">
                <div class="label">其它康复说明</div>
                <div class="value">
                  <el-input v-model="staticInfo.otherRemark" :rows="3" disabled type="textarea"></el-input>
                </div>
              </div>
            </div>
          </div>
          <!-- 其它 -->
          <div class="box">
            <div class="boxTit">
              <div class="boxTitL">其它</div>
              <div class="boxTitR"></div>
            </div>
            <div class="boxCon">
              <div class="line">
                <div class="label">附件</div>
                <div class="value">
                  <div v-if="onlySee()">
                    <div v-if="!$public.isNull(staticInfo.filePath)">
                      <div @click="openWindiw(staticInfo.filePath)" style="
                          font-size: 12px;
                          color: rgb(94, 123, 250);
                          line-height: 32px;
                          cursor: pointer;
                          display: inline-block;
                        ">
                        {{
      staticInfo.filePath.substr(
        staticInfo.filePath.length - 35
      )
    }}
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="$public.isNull(staticInfo.filePath)" style="
                        background-color: #f9fbff;
                        font-size: 12px;
                        color: #5e7bfa;
                        width: 110px;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 4px;
                        cursor: pointer;
                      " @click="upload('enclosure', '')">
                      +上传图片
                    </div>
                    <div v-else>
                      <div @click="openWindiw(staticInfo.filePath)" style="
                          font-size: 12px;
                          color: rgb(94, 123, 250);
                          line-height: 32px;
                          cursor: pointer;
                          display: inline-block;
                        ">
                        {{
      staticInfo.filePath.substr(
        staticInfo.filePath.length - 35
      )
    }}
                      </div>
                      <div style="
                          background-color: #f9fbff;
                          font-size: 12px;
                          color: #5e7bfa;
                          width: 110px;
                          text-align: center;
                          line-height: 30px;
                          border-radius: 4px;
                          cursor: pointer;
                          display: inline-block;
                          margin-left: 20px;
                        " @click="upload('enclosure', '')">
                        重新上传
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="R">
          <div class="tabLine">
            <div class="tabItem" :class="[curTabIndex === 0 ? 'active' : '']" @click="curTabIndex = 0">
              历史病例
            </div>
            <div class="tabItem" :class="[curTabIndex === 1 ? 'active' : '']" @click="curTabIndex = 1">
              治疗建议
            </div>
            <div class="tabItem" :class="[curTabIndex === 2 ? 'active' : '']" @click="curTabIndex = 2">
              智能处方
            </div>
          </div>
          <div class="tabCon" v-if="!$public.isNull(staticInfo.caseNumber)">
            <!-- 历史病例 -->
            <bingliTab0 :initCaseNumber="staticInfo.caseNumber" v-show="curTabIndex === 0"></bingliTab0>
            <!-- 治疗建议 -->
            <bingliTab1 v-show="curTabIndex === 1"></bingliTab1>
            <!-- 智能处方 -->
            <bingliTab2 v-show="curTabIndex === 2 && RLoadingState" :blItem="staticInfo"
              :diagnosisTags="bingliTab2Prop_diagnosisTags" @submit="addGoodsManyApi"></bingliTab2>
          </div>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL">
        <span v-if="orderNumber !== ''">
          有未支付订单，
          <span style="color: #32a05b; cursor: pointer" @click="openDialogQRCode">去支付</span>
          <span style="color: red; cursor: pointer; margin-left: 10px" @click="closeOrder">取消</span>
        </span>
      </div>
      <div class="settlementR">
        <div class="text">
          已支付：
          <span style="color: #5e7bfa; font-size: 18px; margin-right: 20px">
            ￥
            {{
      $public.jia(
        tableMoney1.paid,
        tableMoney2.paid,
        tableMoney3.paid,
        tableMoney4.paid,
        tableMoney5.paid,
        tableMoney6.paid
      )
    }}
          </span>
          待支付：
          <span style="color: #f5882a; font-size: 18px; margin-right: 20px">
            ￥
            {{
        $public.jia(
          tableMoney1.unpaid,
          tableMoney2.unpaid,
          tableMoney3.unpaid,
          tableMoney4.unpaid,
          tableMoney5.unpaid,
          tableMoney6.unpaid
        )
      }}
          </span>
          会员价：
          <span style="color: #333336; font-size: 18px; margin-right: 20px">
            ￥
            {{
        $public.jia(
          tableMoney1.vipTotal,
          tableMoney2.vipTotal,
          tableMoney3.vipTotal,
          tableMoney4.vipTotal,
          tableMoney5.vipTotal,
          tableMoney6.vipTotal
        )
      }}
          </span>
          总计：
          <span style="color: #333336; font-size: 18px; margin-right: 20px">
            ￥
            {{
        $public.jia(
          tableMoney1.total,
          tableMoney2.total,
          tableMoney3.total,
          tableMoney4.total,
          tableMoney5.total,
          tableMoney6.total
        )
      }}
          </span>
        </div>
        <el-button v-if="!onlySee()" type="warning" size="small" @click="createOrder">生成订单</el-button>
      </div>
    </div>
    <!-- 检测 -->
    <div v-if="dialogAddGoods1_state">
      <dialogAddShop :addShopState="dialogAddGoods1_state" :shopId="curShopId" :tree="[
      {
        id: '601d11cfa93f55b5cf3ae2eb',
        children: [{ id: '601d11d0a93f55b5cf3ae2fa' }],
      },
      {
        id: '602f1e88c904d9db7ccf3bec',
        children: [{ id: '602f1e88c904d9db7ccf3bf2' }],
      },
    ]" @submit="submit_dialogAddGoods1" @closeOn="dialogAddGoods1_state = false"></dialogAddShop>
    </div>
    <!-- 处方 -->
    <div v-if="dialogAddGoods2_state">
      <!-- <dialogAddGoods :labelType="addGoods_labelType" @select="selectGoods" @close="dialogAddGoods_state=false"></dialogAddGoods> -->
      <dialogAddShop :addShopState="dialogAddGoods2_state" :shopId="curShopId"
        :medicineTag="getMedicineTagForDialogAddProduct()" :tree="[
      {
        id: '602f1e88c904d9db7ccf3bec',
        children: [
          { id: '602f1e88c904d9db7ccf3bed' },
          { id: '602f1e89c904d9db7ccf3bf6' },
          { id: '602f1e89c904d9db7ccf3bfc' },
          { id: '602f1e89c904d9db7ccf3bff' },
        ],
      },
    ]" @submit="submit_dialogAddGoods2" @closeOn="dialogAddGoods2_state = false"></dialogAddShop>
    </div>
    <!-- 并发症处方 -->
    <div v-if="dialogAddGoods6_state">
      <!-- <dialogAddGoods :labelType="addGoods_labelType" @select="selectGoods" @close="dialogAddGoods_state=false"></dialogAddGoods> -->
      <dialogAddShop :addShopState="dialogAddGoods6_state" :shopId="curShopId"
        :medicineTag="getMedicineTag1ForDialogAddProduct()" :tree="[
      {
        id: '602f1e88c904d9db7ccf3bec',
        children: [
          { id: '602f1e88c904d9db7ccf3bed' },
          { id: '602f1e89c904d9db7ccf3bf6' },
          { id: '602f1e89c904d9db7ccf3bfc' },
          { id: '602f1e89c904d9db7ccf3bff' },
        ],
      },
    ]" @submit="submit_dialogAddGoods6" @closeOn="dialogAddGoods6_state = false"></dialogAddShop>
    </div>
    <!-- 处置 -->
    <div v-if="dialogAddGoods3_state">
      <dialogAddShop :addShopState="dialogAddGoods3_state" :shopId="curShopId" :tree="[
      {
        id: '601d11cfa93f55b5cf3ae2eb',
        children: [{ id: '601d11cfa93f55b5cf3ae2ec' }],
      },
    ]" @submit="submit_dialogAddGoods3" @closeOn="dialogAddGoods3_state = false"></dialogAddShop>
    </div>
    <!-- 手术 -->
    <div v-if="dialogAddGoods4_state">
      <dialogAddShop :addShopState="dialogAddGoods4_state" :shopId="curShopId" :tree="[
      {
        id: '601d11cfa93f55b5cf3ae2eb',
        children: [{ id: '601d11d0a93f55b5cf3ae2f2' }],
      },
    ]" @submit="submit_dialogAddGoods4" @closeOn="dialogAddGoods4_state = false"></dialogAddShop>
    </div>
    <!-- 用法用量 -->
    <div v-if="dialogYfyl_state">
      <dialogYfyl :row="curRow" @submit="submit_dialogYfyl"></dialogYfyl>
    </div>
    <!-- 扫码支付 -->
    <div v-if="dialogQRCode_state">
      <dialogQRCode :QRCode="codeUrl" :orderNum="orderNumber" @submit="submit_dialogQRCode"></dialogQRCode>
    </div>
    <!-- 结算 -->
    <div v-if="dialogShouyin_state">
      <dialogShouyin :bingliMsg="staticInfo" :selectedArr="selectedArr" @submit="submit_shouyin" @close="close_shouyin">
      </dialogShouyin>
    </div>
    <!-- 复制 -->
    <div v-if="dialogCopy_state">
      <dialogCopy :bingliObj="staticInfo" @close="dialogCopy_state = false"></dialogCopy>
    </div>
    <!-- 打印 -->
    <div v-if="dialogPrintRreview_state">
      <dialogPrintRreview :bingliObj="staticInfo" @submit="dialogPrintRreview_state = false"></dialogPrintRreview>
    </div>
    <!-- 住院 -->
    <div v-if="dialogAddZhuyuan_state">
      <dialogAddZhuyuan :bingliMsg="staticInfo" @submit="submit_addZhuyuan" @close="dialogAddZhuyuan_state = false">
      </dialogAddZhuyuan>
    </div>
    <!-- 编辑住院 -->
    <div v-if="dialogEditZhuyuan_state">
      <dialogEditZhuyuan :zhuyuanMsg="curPetZhuyuanList[0]" @submit="submit_editZhuyuan"
        @close="dialogEditZhuyuan_state = false"></dialogEditZhuyuan>
    </div>
    <!-- 过敏史 -->
    <div v-if="drawerAllergyList_state">
      <drawerAllergyList :blItem="staticInfo" @submit="submit_drawerAllergyList"></drawerAllergyList>
    </div>

    <!-- 检测报告 -->
    <div v-if="dialogBingliChecked_state">
      <dialogBingliChecked :bingliObj="staticInfo" @submit="
      dialogBingliChecked_state = false;
    getIllnessCase();
    "></dialogBingliChecked>
    </div>
    <!-- 康复情况 -->
    <div v-if="dialogRecoveryState_state">
      <dialogRecoveryState :recoveryState="recoveryState" @submit="submit_dialogRecoveryState">
      </dialogRecoveryState>
    </div>
    <!-- 选择支付方式 医疗-->
    <div v-if="yiliao_state">
      <dialogYiLiao :orderNum="orderNumber" @submit="submityiLiao"></dialogYiLiao>
    </div>
    <!-- 添加备注 -->
    <el-dialog title="备注" :visible.sync="dialogAddRemark_state" :width="'500px'" @close="dialogAddRemark_state = false">
      <span>
        <el-input type="textarea" v-model="curRow.remark" rows="5" placeholder="请输入备注"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit_dialogAddRemark">确 定</el-button>
      </span>
    </el-dialog>
    <input type="file" style="width: 0; height: 0" ref="file" @change="changeFile" />
  </div>
</template>
<script>
import dialogAddShop from "../../../../components/dialog_addShop.vue";
import bingliTab0 from "./bingli_tab0.vue";
import bingliTab1 from "./bingli_tab1.vue";
import bingliTab2 from "./bingli_tab2.vue";
import dialogYfyl from "../drawer/dialog_yfyl.vue";
import dialogQRCode from "../../../../components/dialogQRCode.vue";
import dialogShouyin from "../../../../components/dialogShouyinBl.vue";
import dialogCopy from "../../../../components/dialogCopy.vue";
import dialogPrintRreview from "../drawer/dialogPrintPreview.vue";
import dialogAddZhuyuan from "../../../../components/dialogAddZhuyuan.vue";
import dialogEditZhuyuan from "../../../../components/dialogEditZhuyuan.vue";
import drawerAllergyList from "../drawer/drawer_allergyList.vue";
import dialogBingliChecked from "../drawer/dialogBingliChecked.vue";
import dialogRecoveryState from "../drawer/dialogRecoveryState.vue";
import dialogYiLiao from "../../../../components/dialog_yiliao.vue";
export default {
  components: {
    bingliTab0,
    bingliTab1,
    bingliTab2,
    dialogYiLiao,
    dialogAddShop,
    dialogYfyl,
    dialogQRCode,
    dialogShouyin,
    dialogCopy,
    dialogPrintRreview,
    dialogAddZhuyuan,
    dialogEditZhuyuan,
    drawerAllergyList,
    dialogBingliChecked,
    dialogRecoveryState,
  },
  data() {
    return {
      shopId: this.$store.state.shopId,
      guahaoDetail: {
        status: 0,
      },
      yiliao_state: false,
      staticInfo: null,
      selectedArr: [], // 总的
      selectedArr1: [],
      selectedArr2: [],
      selectedArr3: [],
      selectedArr4: [],
      selectedArr5: [],
      selectedArr6: [],
      tableMoney1: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      tableMoney2: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      tableMoney3: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      tableMoney4: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      tableMoney5: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      tableMoney6: {
        total: 0,
        paid: 0,
        unpaid: 0,
        vipTotal: 0
      },
      dialogAddGoods1_state: false,
      dialogAddGoods2_state: false,
      dialogAddGoods3_state: false,
      dialogAddGoods4_state: false,
      dialogAddGoods6_state: false,

      // 用法用量
      dialogYfyl_state: false,
      curRow: {},

      // 上传
      uploadType: "",

      // 回访
      visitResultId: "",
      resultList: [],
      huifangContent: "",
      huifangHistoryList: [],
      nextHuifangRadio: true,

      // 未支付订单
      orderNumber: "",
      dialogQRCode_state: false,
      codeUrl: "",

      // 结算弹窗
      dialogShouyin_state: false,

      // 复制
      dialogCopy_state: false,

      // 打印
      dialogPrintRreview_state: false,

      // 住院
      dialogAddZhuyuan_state: false,
      // 编辑住院
      zhuyuanTableState: true,
      curPetZhuyuanList: [],
      dialogEditZhuyuan_state: false,

      visitTime: "", // 回访时间
      againSeeTime: "", // 复诊时间

      curTag_old: [], // 医疗标签
      curTag: [], // 医疗标签
      tagTree: [],
      TagDictionary: {},

      // 并发症
      complicationRadio: false,
      curTag_complication_old: [], // 并发症
      curTag_complication: [], // 并发症
      curTag_complicationCause_old: [], // 并发症原因
      curTag_complicationCause: [], // 并发症原因

      // 过敏史
      drawerAllergyList_state: false,

      // 检测报告
      dialogBingliChecked_state: false,

      // 科室
      departmentList: [],

      form: {
        departmentId: "", // 科室
        animalHeat: "", // 体温               double
        weight: "", // 体重                   double
        breatheRate: "", // 呼吸率               int32
        heartRate: "", //心率                   int32
        mainContent: "", // 主诉
        clinecContent: "", // 临床检查
        diagnosis: "", // 病情诊断
        analyzeContent: "", // 检查分析
        conditionLevel: 0,
        cureContent: "", // 处理诊断
        doctorAdvice: "", // 医嘱
        remark: "", //其他备注

        filePath: "", //附件路径
        visitDays: 0,
        againSeeDays: 0,
        againSeeNoticeType: 0,
        contactName: "",
        contactMobile: "",
        completeState: 0,
        diedCause: 0,
        diedRemark: "",
      },
      // 右侧
      curTabIndex: 0,
      RLoadingState: true,
      // 智能处方参数标签
      bingliTab2Prop_diagnosisTags: [],

      // 康复情况
      dialogRecoveryState_state: false,
      recoveryState: 1,

      // 添加备注
      dialogAddRemark_state: false,

      // inputTimer
      timer: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
    bingliParams() {
      return this.$store.state.yiliaoxin.bingliParams;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  watch: {
    bingliParams: {
      handler(n, o) {
        this.getIllnessCase();
      },
      deep: true,
    },
  },
  created() {
    this.getIllnessCase("changeUserInfo");
    this.getPayAddr(); // 获取待支付订单
    this.getMedicineTag();
    this.getDepartmentList();
    this.$http
      .get(
        process.env.VUE_APP_zichan + "/api/SystemConfig/GetSystemDictionByCode",
        {
          code: "visitresult",
        }
      )
      .then((res) => {
        if (res.code === 0) {
          this.resultList = res.data.item_list;
        }
      });
  },
  mounted() { },
  methods: {
    changeNum(row) {
      let in_exchanage = JSON.parse(row.extendContent).in_exchanage || 1;
      let goodsDosage = this.$public.cheng(row.num, in_exchanage);
      row.goodsDosage = goodsDosage;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.changeGoodsApi(row);
        }, 500);
      } else {
        this.timer = setTimeout(() => {
          this.changeGoodsApi(row);
        }, 500);
      }
    },
    changeDosage(row) {
      let in_exchanage = JSON.parse(row.extendContent).in_exchanage || 1;
      let num = Math.ceil(
        this.$public.chu(Number(row.goodsDosage), in_exchanage)
      );
      row.num = num;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.changeGoodsApi(row);
      }, 500);
    },
    // 处理门店库存
    FShopStock(arr) {
      let stock = -1;
      if (!arr[0]) {
        return (arr = []);
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].shopId == this.shopId) {
          stock = arr[i].stock;

        }
      }
      return [
        stock
      ];
    },
    // 关闭医疗支付弹框
    submityiLiao() {
      this.yiliao_state = false;
    },
    // 返回
    back() {
      if (!this.onlySee()) {
        this.changeIllnessCase("defaultSave");
      }
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.bingliParams.type = "list";
        this.$store.commit("yiliaoxin/set_bingliParams", this.bingliParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "病例");
      }
    },
    // 修改数字
    changeTextNum() {
      this.form.animalHeat = this.$public.replaceGoodsDosage(
        this.form.animalHeat
      );
      this.form.weight = this.$public.replaceGoodsDosage(this.form.weight);
      this.form.breatheRate = this.$public.replaceGoodsDosage(
        this.form.breatheRate
      );
      this.form.heartRate = this.$public.replaceGoodsDosage(
        this.form.heartRate
      );
    },
    filterThreeTag(n, o) {
      // [1,2,3],[1,2,3]
      // 分组
      // let nObj = {}
      // let oObj = {}
      // n.map((item)=>{
      // 	if(nObj[item[1]]===undefined){
      // 		nObj[item[1]] = [item]
      // 	}else{
      // 		nObj[item[1]].push(item)
      // 	}
      // })
      // o.map((item)=>{
      // 	if(oObj[item[1]]===undefined){
      // 		oObj[item[1]] = [item]
      // 	}else{
      // 		oObj[item[1]].push(item)
      // 	}
      // })
      // // 匹配
      // let res = []
      // for(let keyN in nObj){
      // 	let deng = false
      // 	for(let keyO in oObj){
      // 		if(keyN===keyO){
      // 			deng = true
      // 		}
      // 	}
      // 	if(deng===true){
      // 		let tong = true
      // 		for(let i=0;i<nObj[keyN].length;i++){
      // 			if(JSON.stringify(nObj[keyN][i])!==JSON.stringify(oObj[keyN][0])){
      // 				tong = false
      // 			}
      // 		}
      // 		console.log(tong)
      // 		if(tong === true){
      // 			res.push(oObj[keyN][0])
      // 		}else{
      // 			// nObj[keyN].map((item)=>{
      // 			for(let q=0;q<nObj[keyN].length;q++){
      // 				let item = nObj[keyN][q]
      // 				if(JSON.stringify(item)!==JSON.stringify(oObj[keyN][0])){
      // 					res.push(item)
      // 					break;
      // 				}
      // 			}
      // 		}
      // 	}else{
      // 		res.push(nObj[keyN][0])
      // 	}
      // }
      return n;
    },
    // 修改 医疗标签
    changeTagTree(e) {
      let curTag = this.filterThreeTag(e, this.curTag_old);
      this.curTag_old = this.curTag = curTag;
      this.RLoadingState = false;
      this.$nextTick(() => {
        this.RLoadingState = true;
      });
      let diagnosisTags = [];
      for (let a = 0; a < this.tagTree.length; a++) {
        let item = {
          key: this.tagTree[a].key,
          value: this.tagTree[a].value,
          symptom: [],
        };
        for (let i = 0; i < this.curTag.length; i++) {
          if (this.curTag[i][0] === this.tagTree[a].key) {
            for (let b = 0; b < this.tagTree[a].symptom.length; b++) {
              if (this.curTag[i][1] === this.tagTree[a].symptom[b].key) {
                let two = {
                  key: this.tagTree[a].symptom[b].key,
                  value: this.tagTree[a].symptom[b].value,
                  symptomLevel: [],
                };
                for (
                  let c = 0;
                  c < this.tagTree[a].symptom[b].symptom.length;
                  c++
                ) {
                  if (
                    this.curTag[i][2] ===
                    this.tagTree[a].symptom[b].symptom[c].key
                  ) {
                    two.symptomLevel.push({
                      key: this.tagTree[a].symptom[b].symptom[c].key,
                      value: this.tagTree[a].symptom[b].symptom[c].value,
                    });
                  }
                }
                item.symptom.push(two);
              }
            }
          }
        }
        if (item.symptom.length > 0) {
          diagnosisTags.push(item);
        }
      }
      this.bingliTab2Prop_diagnosisTags = diagnosisTags;
    },
    getComplicationCauseList() {
      let arr = [];
      let curTag = this.bingliTab2Prop_diagnosisTags;
      for (let i = 0; i < curTag.length; i++) {
        let list = {
          key: curTag[i].key,
          value: curTag[i].value,
          symptom: [],
        };
        for (let a = 0; a < curTag[i].symptom.length; a++) {
          let two = {
            key: curTag[i].symptom[a].key,
            value: curTag[i].symptom[a].value,
            symptom: [],
          };
          for (let b = 0; b < curTag[i].symptom[a].symptomLevel.length; b++) {
            two.symptom.push({
              key: curTag[i].symptom[a].symptomLevel[b].key,
              value: curTag[i].symptom[a].symptomLevel[b].value,
            });
          }
          list.symptom.push(two);
        }
        arr.push(list);
      }
      return arr;
    },
    changeComplication(e) {
      let aa = this.filterThreeTag(e, this.curTag_complication_old);
      this.curTag_complication_old = this.curTag_complication = aa;
    },
    changeComplicationCause(e) {
      let aa = this.filterThreeTag(e, this.curTag_complicationCause_old);
      this.curTag_complicationCause_old = this.curTag_complicationCause = aa;
    },
    // 修改 用法用量
    submit_dialogYfyl(obj) {
      this.dialogYfyl_state = false;
      if (obj.type === "success") {
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.getIllnessCase();
      }
    },
    // 康复情况
    changeCompleteState(e) {
      this.recoveryState = e;
      this.changeIllnessCase("去归档");
    },
    submit_dialogRecoveryState(obj) {
      this.dialogRecoveryState_state = false;
      if (obj.type === "success") {
        this.changeIllnessCase("归档", obj.data);
      } else if (obj.type === "close") {
        this.form.completeState = 1;
      }
    },
    // 添加备注
    submit_dialogAddRemark() {
      this.$http
        .get("/api/Case/Goods/AddRemark", {
          itemsId: this.curRow.itemsId,
          remark: this.curRow.remark,
        })
        .then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogAddRemark_state = false;
          this.dialogAddRemark_value = "";
          this.getIllnessCase();
        });
    },
    // 上传
    upload(type, row) {
      this.changeIllnessCase("defaultSave");
      if (type == "enclosure") {
        this.uploadType = "enclosure";
      } else if (type == "petImg") {
        this.uploadType = "petImg";
      } else {
        this.curRow = row;
        this.uploadType = type;
      }
      this.$refs.file.click();
    },
    changeFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "doc" || ext === "docx") {
        // ||ext==='txt'
        if (this.uploadType === "petImg") {
          this.$message({
            message: "只能上传jpg,jpeg,png格式的图片",
            type: "error",
          });
          return;
        }
        formData.append("file", e.target.files[0]);
        this.$util.uploadFile(formData).then((data) => {
          if (data.timestamp) {
            if (this.uploadType === "enclosure") {
              // 上传附件
              this.$http
                .get("/api/Case/upload/file", {
                  filePath: data.url,
                  caseNumber: this.staticInfo.caseNumber,
                })
                .then(() => {
                  this.$message({
                    message: "上传成功",
                    type: "success",
                  });
                  this.getIllnessCase();
                });
            } else if (this.uploadType == "petImg") {
              this.$http
                .post("/api/Case/upload/image", {
                  imagePath: [data.url],
                  caseNumber: this.staticInfo.caseNumber,
                })
                .then(() => {
                  this.$message({
                    message: "上传成功",
                    type: "success",
                  });
                  this.getIllnessCase();
                });
            } else {
              this.$http
                .post("/api/Case/HandleInspect", {
                  filePath: data.url,
                  inspectId: this.curRow.id,
                  result: "",
                })
                .then(() => {
                  this.$message({
                    message: "上传成功",
                    type: "success",
                  });
                  this.getIllnessCase();
                });
            }
          }
        });
      } else if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util
          .uploadImg_dir(formData, {
            dir: "businessShop",
          })
          .then((data) => {
            if (data.timestamp) {
              if (this.uploadType === "enclosure") {
                // 上传附件
                this.$http
                  .get("/api/Case/upload/file", {
                    filePath: data.url,
                    caseNumber: this.staticInfo.caseNumber,
                  })
                  .then(() => {
                    this.$message({
                      message: "上传成功",
                      type: "success",
                    });
                    this.getIllnessCase();
                  });
              } else if (this.uploadType == "petImg") {
                this.$http
                  .post("/api/Case/upload/image", {
                    imagePath: [data.url],
                    caseNumber: this.staticInfo.caseNumber,
                  })
                  .then(() => {
                    this.$message({
                      message: "上传成功",
                      type: "success",
                    });
                    this.getIllnessCase();
                  });
              } else {
                this.$http
                  .post("/api/Case/HandleInspect", {
                    filePath: data.url,
                    inspectId: this.curRow.id,
                    result: "",
                  })
                  .then(() => {
                    this.$message({
                      message: "上传成功",
                      type: "success",
                    });
                    this.getIllnessCase();
                  });
              }
            }
          });
      } else {
        this.$message({
          message: "只能上传doc,jpg,png格式的文件",
          type: "error",
        });
      }
      this.$refs.file.value = null;
    },
    // 递归
    // let list = [
    // 	['1','12','124'],
    // 	['1','13','133'],
    // 	['2','21','211'],
    // 	['2','21','212'],
    // ] 和 字典
    dg(list, dictionary) {
      let obj = {};
      for (let i = 0; i < list.length; i++) {
        if (list[i].length === 1) {
          obj[list[i][0]] = [];
        } else {
          if (obj[list[i][0]] === undefined) {
            obj[list[i][0]] = [list[i]];
          } else {
            obj[list[i][0]].push(list[i]);
          }
        }
      }
      for (let key in obj) {
        let list1 = JSON.parse(JSON.stringify(obj[key]));
        list1.map((item) => {
          return item.shift();
        });
        obj[key] = this.dg(list1, dictionary);
      }
      let res = [];
      for (let key in obj) {
        res.push({
          key: key,
          value: dictionary[key],
          child: obj[key],
        });
      }
      return res;
    },
    // 修改病例信息
    changeIllnessCase(str, obj) {
      if (this.staticInfo.completeState !== 1) {
        return;
      }
      if (
        str === "saveBtn" ||
        str === "去归档" ||
        str === "归档" ||
        str === "createOrder"
      ) {
        if (this.complicationRadio === true) {
          if (this.$public.isNull(this.curTag_complication)) {
            this.$message({
              message: "请选择并发症",
              type: "error",
            });
            this.form.completeState = 1;
            return;
          }
          if (this.$public.isNull(this.curTag_complicationCause)) {
            this.$message({
              message: "请选择并发症原因",
              type: "error",
            });
            this.form.completeState = 1;
            return;
          }
        }
      }

      // 病情诊断 回访时间 复诊时间 需要单独处理
      let visitTime = this.$public.FTimeStr10(this.visitTime);
      let againSeeTime = this.$public.FTimeStr10(this.againSeeTime);
      // 病情诊断
      let diagnosisTags = [];
      let arr = this.dg(this.curTag, this.TagDictionary);
      for (let i = 0; i < arr.length; i++) {
        let item = {
          key: arr[i].key,
          value: arr[i].value,
          symptom: [],
        };
        for (let a = 0; a < arr[i].child.length; a++) {
          item.symptom.push({
            key: arr[i].child[a].key,
            value: arr[i].child[a].value,
            symptomLevel: [],
          });
          for (let b = 0; b < arr[i].child[a].child.length; b++) {
            item.symptom[a].symptomLevel.push({
              key: arr[i].child[a].child[b].key,
              value: arr[i].child[a].child[b].value,
            });
          }
        }
        diagnosisTags.push(item);
      }
      let complication = [];
      arr = this.dg(this.curTag_complication, this.TagDictionary);
      for (let i = 0; i < arr.length; i++) {
        let item = {
          key: arr[i].key,
          value: arr[i].value,
          symptom: [],
        };
        for (let a = 0; a < arr[i].child.length; a++) {
          item.symptom.push({
            key: arr[i].child[a].key,
            value: arr[i].child[a].value,
            symptomLevel: [],
          });
          for (let b = 0; b < arr[i].child[a].child.length; b++) {
            item.symptom[a].symptomLevel.push({
              key: arr[i].child[a].child[b].key,
              value: arr[i].child[a].child[b].value,
            });
          }
        }
        complication.push(item);
      }
      let complicationCause = [];
      arr = this.dg(this.curTag_complicationCause, this.TagDictionary);
      for (let i = 0; i < arr.length; i++) {
        let item = {
          key: arr[i].key,
          value: arr[i].value,
          symptom: [],
        };
        for (let a = 0; a < arr[i].child.length; a++) {
          item.symptom.push({
            key: arr[i].child[a].key,
            value: arr[i].child[a].value,
            symptomLevel: [],
          });
          for (let b = 0; b < arr[i].child[a].child.length; b++) {
            item.symptom[a].symptomLevel.push({
              key: arr[i].child[a].child[b].key,
              value: arr[i].child[a].child[b].value,
            });
          }
        }
        complicationCause.push(item);
      }
      let params = {
        caseNumber: this.bingliParams.curRow.caseNumber,
        imagePath: this.staticInfo.imagePath,
        departmentId: this.form.departmentId,
        animalHeat: this.form.animalHeat,
        weight: this.form.weight,
        breatheRate: this.form.breatheRate,
        heartRate: this.form.heartRate,
        mainContent: this.form.mainContent,
        clinecContent: this.form.clinecContent,
        analyzeContent: this.form.analyzeContent,
        diagnosis: this.form.diagnosis,
        diagnosisTags: diagnosisTags,
        complication: this.complicationRadio === false ? "" : complication,
        complicationCause:
          this.complicationRadio === false ? "" : complicationCause,
        conditionLevel: this.form.conditionLevel,
        cureContent: this.form.cureContent,
        doctorAdvice: this.form.doctorAdvice,
        remark: this.form.remark,
        filePath: this.form.filePath,
        visitDate: this.nextHuifangRadio === false ? "" : visitTime,
        visitDays: this.nextHuifangRadio === false ? 0 : this.form.visitDays,
        againSeeDate: againSeeTime,
        againSeeDays: this.form.againSeeDays,
        againSeeNoticeType: 1, // 复诊单项或双向提醒  1：单项    2：双向
        contactName: this.form.contactName,
        contactMobile: this.form.contactMobile,

        completeState: str === "归档" ? this.recoveryState : 1,
        diedCause:
          str === "归档" && this.recoveryState === 3 ? obj.diedCause : 0,
        diedRemark:
          str === "归档" && this.recoveryState === 3 ? obj.diedRemark : "",
        otherRemark:
          str === "归档" && this.recoveryState === 4 ? obj.otherRemark : "",
      };
      let loading = this.$loading();
      this.$http.post("/api/Case/Update", params).then((res) => {
        loading.close();
        if (res.code === 0) {
          if (str === "saveBtn") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getIllnessCase();
          } else if (str === "createOrder") {
            this.dialogShouyin_state = true;
            this.getIllnessCase();
          } else if (str === "去归档") {
            this.dialogRecoveryState_state = true;
            this.getIllnessCase();
          } else if (str === "归档") {
            this.getIllnessCase();
          } else {
            console.log("默认保存");
          }
        }
      });
    },

    addGoodsApi(caseItemId, row) {
      this.changeIllnessCase("defaultSave");
      let illnessStates = [];
      if (!this.$public.isNull(row.tags)) {
        for (let i = 0; i < row.tags.length; i++) {
          let item1 = {
            key: row.tags[i].code,
            value: row.tags[i].name,
            symptom: [],
          };
          for (let a = 0; a < row.tags[i].subs.length; a++) {
            item1.symptom.push({
              key: row.tags[i].subs[a].code,
              value: row.tags[i].subs[a].name,
              symptomLevel: [],
            });
            for (let b = 0; b < row.tags[i].subs[a].subs.length; b++) {
              item1.symptom[a].symptomLevel.push({
                key: row.tags[i].subs[a].subs[b].code,
                value: row.tags[i].subs[a].subs[b].name,
              });
            }
          }
          illnessStates.push(item1);
        }
      }
      let params = {
        caseNumber: this.staticInfo.caseNumber, // 病例号
        caseItemId: caseItemId, // 1检查；2处方；3处置；4手术；5住院  6并发症
        smartRecipeId: "", // 智能处方id
        illnessStates: illnessStates, // 病情标签
        goods: {
          goodsUsage: [],
          goodsDosage: row.goodsDosage || 0, // Desc:用量
          allowWholesale: row.allow_wholesale, // 是否按最大单位销售
          dosageCeiling: row.dosageCeiling, // 出库量向上取整
          dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
          goodsId: row.goodsId,
          goodsName: row.goodsName,
          otherName: row.otherName, // 别名
          isHumanMedication: row.isHumanMedication,
          goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
          brand: row.brand,
          categoryId: row.categoryId,
          categoryName: row.categoryName,
          skus: row.skus, // 商品skuid
          skuValue: row.skuValue, // 商品sku规格
          unitId: "", // 商品单位id  药品没有此字段
          unit: row.unit, // 商品单位
          outUnit: row.outUnit, // 出库单位
          originalPrice: row.originalPrice,
          price: row.price,
          vipPrice: row.mprice,
          num: row.num,
          stock_detail: row.stock_detail,
          joinCommission: 1, // 1 参与 2 不参与
          extendContent: JSON.stringify({
            in_exchanage: row.in_exchanage || 1,
          }),
        },
      };

      let loading = this.$loading();
      this.$http.post("/api/Case/Goods/Add", params).then((res) => {
        loading.close();
        if (res.code === 0) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.getIllnessCase();
        }
      });
    },
    addGoodsManyApi(list) {
      this.changeIllnessCase("defaultSave");
      let arr = [];
      for (let x = 0; x < list.length; x++) {
        let row = this.$public.getRow(list[x], "无", "无", 1);
        let table = this.staticInfo.recipelItem;
        let contu = false;
        for (let i = 0; i < table.length; i++) {
          if (this.$public.isNull(table[i].orderNum)) {
            if (table[i].skus == row.skus && table[i].goodsId == row.goodsId) {
              this.$message({
                message: table[i].goodsName + " 该商品已添加",
                type: "error",
              });
              contu = true;
            }
          }
        }
        if (row.stock == 0) {
          this.$message({
            message: row.goodsName + " 该商品已没有库存，请及时申请采购",
            type: "error",
          });
          contu = true;
        }
        if (contu === true) {
          continue;
        }
        let illnessStates = [];
        if (!this.$public.isNull(row.tags)) {
          for (let i = 0; i < row.tags.length; i++) {
            let item1 = {
              key: row.tags[i].code,
              value: row.tags[i].name,
              symptom: [],
            };
            for (let a = 0; a < row.tags[i].subs.length; a++) {
              item1.symptom.push({
                key: row.tags[i].subs[a].code,
                value: row.tags[i].subs[a].name,
                symptomLevel: [],
              });
              for (let b = 0; b < row.tags[i].subs[a].subs.length; b++) {
                item1.symptom[a].symptomLevel.push({
                  key: row.tags[i].subs[a].subs[b].code,
                  value: row.tags[i].subs[a].subs[b].name,
                });
              }
            }
            illnessStates.push(item1);
          }
        }
        let caseItemId = 2;
        arr.push({
          caseNumber: this.staticInfo.caseNumber, // 病例号
          caseItemId: caseItemId, // 1检查；2处方；3处置；4手术；5住院  6并发症
          smartRecipeId: list[x].smartRecipeId, // 智能处方id
          illnessStates: illnessStates, // 病情标签
          goods: {
            goodsUsage: [],
            goodsDosage: row.goodsDosage || 0, // Desc:用量
            allowWholesale: row.allow_wholesale, // 是否按最大单位销售
            dosageCeiling: row.dosageCeiling, // 出库量向上取整
            dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
            goodsId: row.goodsId,
            goodsName: row.goodsName,
            otherName: row.otherName, // 别名
            isHumanMedication: row.isHumanMedication,
            goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
            brand: row.brand,
            categoryId: row.categoryId,
            categoryName: row.categoryName,
            skus: row.skus, // 商品skuid
            skuValue: row.skuValue, // 商品sku规格
            unitId: "", // 商品单位id  药品没有此字段
            unit: row.unit, // 商品单位
            outUnit: row.outUnit, // 出库单位
            originalPrice: row.originalPrice,
            price: row.price,
            vipPrice: row.mprice,
            num: row.num,
            joinCommission: 1, // 1 参与 2 不参与
            extendContent: JSON.stringify({
              in_exchanage: row.in_exchanage || 1,
            }),
          },
        });
      }
      if (arr.length === 0) {
        return;
      }
      let loading = this.$loading();
      this.$http.post("/api/Case/Goods/AddMany", arr).then((res) => {
        loading.close();
        if (res.code === 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getIllnessCase();
        }
      });
    },
    changeGoodsApi(row) {
      this.changeIllnessCase("defaultSave");
      row.num = this.$public.replaceGoodsDosage(row.num);
      row.goodsDosage = this.$public.replaceGoodsDosage(row.goodsDosage);

      let params = {
        itemsId: row.itemsId,
        num: row.num,
        allowWholesale: row.allowWholesale,
        goodsDosage: Number(row.goodsDosage) || 0,
      };
      if (row.num == 0) {
        params.num = 1;
      }
      let loading = this.$loading();
      this.$http.post("/api/Case/Goods/ChangeCount", params).then((res) => {
        loading.close();
        if (res.code === 0) {
          this.getIllnessCase();
        }
      });
    },
    delGoodsApi(row) {
      this.changeIllnessCase("defaultSave");
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          itemsId: row.itemsId,
        };
        let loading = this.$loading();
        this.$http.delete("/api/Case/Goods/Remove", params).then((res) => {
          loading.close();
          if (res.code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getIllnessCase();
          }
        });
      });
    },
    // 创建订单
    createOrder() {
      let selectedArr = [];
      let selectedArrC = [];
      for (let i = 0; i < this.selectedArr1.length; i++) {
        if (this.selectedArr1[i] === true) {
          selectedArr.push(this.staticInfo.inspectItem[i]);
        }
      }
      for (let i = 0; i < this.selectedArr2.length; i++) {
        if (this.selectedArr2[i] === true) {
          selectedArr.push(this.staticInfo.recipelItem[i]);
          selectedArrC.push(this.staticInfo.recipelItem[i]);
        }
      }
      for (let i = 0; i < this.selectedArr6.length; i++) {
        if (this.selectedArr6[i] === true) {
          selectedArr.push(this.staticInfo.complicationItem[i]);
        }
      }
      for (let i = 0; i < this.selectedArr3.length; i++) {
        if (this.selectedArr3[i] === true) {
          selectedArr.push(this.staticInfo.handleItem[i]);
        }
      }
      for (let i = 0; i < this.selectedArr4.length; i++) {
        if (this.selectedArr4[i] === true) {
          selectedArr.push(this.staticInfo.operationItem[i]);
        }
      }
      for (let i = 0; i < this.selectedArr5.length; i++) {
        if (this.selectedArr5[i] === true) {
          selectedArr.push(this.staticInfo.inHospitalItem[i]);
        }
      }
      this.$util.getGoodsInfo(selectedArrC).then((goodsList) => {
        for (let i = 0; i < goodsList.length; i++) {
          if (
            this.$public.isNull(goodsList[i].orderNum) &&
            goodsList[i].goodsType === 1
          ) {
            for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
              if (goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue) {
                let stock = 0;
                if (goodsList[i].unit === goodsList[i].outUnit) {
                  stock = this.$public.getMatchingItem(
                    goodsList[i].skuStocks[a].lstStock,
                    "shopId",
                    this.curShopId
                  ).totalTimes;
                } else {
                  stock = this.$public.getMatchingItem(
                    goodsList[i].skuStocks[a].lstStock,
                    "shopId",
                    this.curShopId
                  ).stock;
                }
                if (stock == 0) {
                  goodsList[i].num = 0;
                  this.$message({
                    message: goodsList[i].goodsName_a + " 已没有库存",
                    type: "error",
                  });
                  return;
                } else if (stock < goodsList[i].num) {
                  goodsList[i].num = stock;
                  this.$message({
                    message: goodsList[i].goodsName_a + " 库存不足",
                    type: "error",
                  });
                  return;
                } else {
                  console.log("库存充足");
                }
              }
            }
          }
        }
        this.selectedArr = selectedArr.filter((item) => {
          return this.$public.isNull(item.orderNum);
        });
        if (this.selectedArr.length == 0) {
          this.$message({
            message: "请选择需要结算的项目",
            type: "error",
          });
          return;
        } else {
          if (this.form.completeState === 3) {
            if (this.form.diedCause === 0) {
              this.$message({
                message: "请选择死亡原因",
                type: "error",
              });
              return;
            }
            if (this.$public.isNull(this.form.diedRemark)) {
              this.$message({
                message: "请填写死亡描述",
                type: "error",
              });
              return;
            }
          }
          this.changeIllnessCase("createOrder");
        }
      });

    },
    // 结算弹窗
    submit_shouyin() {
      this.dialogShouyin_state = false;
      this.getIllnessCase();
      this.getPayAddr();
      this.getIllnessCase();
    },
    close_shouyin() {
      this.dialogShouyin_state = false;
      this.getPayAddr();
      this.getIllnessCase();
    },
    // 仅查看
    onlySee() {
      let state = true;
      if (this.bingliParams.type === "see") {
        state = true;
      } else if (this.bingliParams.type === "edit") {
        if (this.staticInfo.completeState > 1) {
          state = true;
        } else {
          state = false;
        }
      }
      return state;
    },
    // 粘贴
    paste() {
      let bingli_copy = JSON.parse(sessionStorage.getItem("bingli_copy"));
      this.$confirm("确定要粘贴吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let table1 = [];
        let curBingliTable1 = this.staticInfo.inspectItem;
        for (let i = 0; i < bingli_copy.table1.length; i++) {
          let has = false;
          for (let a = 0; a < curBingliTable1.length; a++) {
            if (
              bingli_copy.table1[i].goodsId === curBingliTable1[a].goodsId &&
              bingli_copy.table1[i].skus === curBingliTable1[a].skus &&
              curBingliTable1[a].isPay != true
            ) {
              has = true;
            }
          }
          if (has === false) {
            table1.push(bingli_copy.table1[i]);
          }
        }
        let table2 = [];
        let curBingliTable2 = this.staticInfo.recipelItem;
        for (let i = 0; i < bingli_copy.table2.length; i++) {
          let has = false;
          for (let a = 0; a < curBingliTable2.length; a++) {
            if (
              bingli_copy.table2[i].goodsId === curBingliTable2[a].goodsId &&
              bingli_copy.table2[i].skus === curBingliTable2[a].skus &&
              curBingliTable2[a].isPay != true
            ) {
              has = true;
            }
          }
          if (has === false) {
            table2.push(bingli_copy.table2[i]);
          }
        }
        let table3 = [];
        let curBingliTable3 = this.staticInfo.handleItem;
        for (let i = 0; i < bingli_copy.table3.length; i++) {
          let has = false;
          for (let a = 0; a < curBingliTable3.length; a++) {
            if (
              bingli_copy.table3[i].goodsId === curBingliTable3[a].goodsId &&
              bingli_copy.table3[i].skus === curBingliTable3[a].skus &&
              curBingliTable3[a].isPay != true
            ) {
              has = true;
            }
          }
          if (has === false) {
            table3.push(bingli_copy.table3[i]);
          }
        }
        let table4 = [];
        let curBingliTable4 = this.staticInfo.operationItem;
        for (let i = 0; i < bingli_copy.table4.length; i++) {
          let has = false;
          for (let a = 0; a < curBingliTable4.length; a++) {
            if (
              bingli_copy.table4[i].goodsId === curBingliTable4[a].goodsId &&
              bingli_copy.table4[i].skus === curBingliTable4[a].skus &&
              curBingliTable4[a].isPay != true
            ) {
              has = true;
            }
          }
          if (has === false) {
            table4.push(bingli_copy.table4[i]);
          }
        }
        let arr = [];
        for (let i = 0; i < table1.length; i++) {
          let row = table1[i];
          arr.push({
            caseNumber: this.staticInfo.caseNumber, // 病例号
            caseItemId: 1, // 1检查；2处方；3处置；4手术；5住院
            goods: {
              goodsUsage: [],
              goodsDosage: row.goodsDosage || 0, // Desc:用量
              allowWholesale: row.allowWholesale, // 是否按最大单位销售
              dosageCeiling: row.dosageCeiling, // 出库量向上取整
              dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
              goodsId: row.goodsId,
              goodsName: row.goodsName,
              otherName: row.otherName, // 别名
              isHumanMedication: row.isHumanMedication,
              goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
              brand: row.brand,
              categoryId: row.categoryId,
              categoryName: row.categoryName,
              skus: row.skus, // 商品skuid
              skuValue: row.skuValue, // 商品sku规格
              unitId: "", // 商品单位id  药品没有此字段
              unit: row.unit, // 商品单位
              outUnit: row.outUnit, // 出库单位
              originalPrice: row.originalPrice,
              vipPrice: row.mprice,
              price: row.price,
              num: row.num,
              joinCommission: 1, // 1 参与 2 不参与
              extendContent: row.extendContent,
            },
          });
        }
        for (let i = 0; i < table2.length; i++) {
          let row = table2[i];
          arr.push({
            caseNumber: this.staticInfo.caseNumber, // 病例号
            caseItemId: 2, // 1检查；2处方；3处置；4手术；5住院
            goods: {
              goodsUsage: [],
              goodsDosage: row.goodsDosage || 0, // Desc:用量
              allowWholesale: row.allowWholesale, // 是否按最大单位销售
              dosageCeiling: row.dosageCeiling, // 出库量向上取整
              dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
              goodsId: row.goodsId,
              goodsName: row.goodsName,
              otherName: row.otherName, // 别名
              isHumanMedication: row.isHumanMedication,
              goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
              brand: row.brand,
              categoryId: row.categoryId,
              categoryName: row.categoryName,
              skus: row.skus, // 商品skuid
              skuValue: row.skuValue, // 商品sku规格
              unitId: "", // 商品单位id  药品没有此字段
              unit: row.unit, // 商品单位
              outUnit: row.outUnit, // 出库单位
              originalPrice: row.originalPrice,
              vipPrice: row.mprice,
              price: row.price,
              num: row.num,
              joinCommission: 1, // 1 参与 2 不参与
              extendContent: row.extendContent,
            },
          });
        }
        for (let i = 0; i < table3.length; i++) {
          let row = table3[i];
          arr.push({
            caseNumber: this.staticInfo.caseNumber, // 病例号
            caseItemId: 3, // 1检查；2处方；3处置；4手术；5住院
            goods: {
              goodsUsage: [],
              goodsDosage: row.goodsDosage || 0, // Desc:用量
              allowWholesale: row.allowWholesale, // 是否按最大单位销售
              dosageCeiling: row.dosageCeiling, // 出库量向上取整
              dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
              goodsId: row.goodsId,
              goodsName: row.goodsName,
              otherName: row.otherName, // 别名
              isHumanMedication: row.isHumanMedication,
              goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
              brand: row.brand,
              categoryId: row.categoryId,
              categoryName: row.categoryName,
              skus: row.skus, // 商品skuid
              skuValue: row.skuValue, // 商品sku规格
              unitId: "", // 商品单位id  药品没有此字段
              unit: row.unit, // 商品单位
              outUnit: row.outUnit, // 出库单位
              originalPrice: row.originalPrice,
              vipPrice: row.mprice,
              price: row.price,
              num: row.num,
              joinCommission: 1, // 1 参与 2 不参与
              extendContent: row.extendContent,
            },
          });
        }
        for (let i = 0; i < table4.length; i++) {
          let row = table4[i];
          arr.push({
            caseNumber: this.staticInfo.caseNumber, // 病例号
            caseItemId: 4, // 1检查；2处方；3处置；4手术；5住院
            goods: {
              goodsUsage: [],
              goodsDosage: row.goodsDosage || 0, // Desc:用量
              allowWholesale: row.allowWholesale, // 是否按最大单位销售
              dosageCeiling: row.dosageCeiling, // 出库量向上取整
              dosageCeilingValue: row.dosageCeilingValue, // 出库量向上取整小数位
              goodsId: row.goodsId,
              goodsName: row.goodsName,
              isHumanMedication: row.isHumanMedication,
              otherName: row.otherName, // 别名
              goodsType: row.goodsType, // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
              brand: row.brand,
              categoryId: row.categoryId,
              categoryName: row.categoryName,
              skus: row.skus, // 商品skuid
              skuValue: row.skuValue, // 商品sku规格
              unitId: "", // 商品单位id  药品没有此字段
              unit: row.unit, // 商品单位
              outUnit: row.outUnit, // 出库单位
              originalPrice: row.originalPrice,
              vipPrice: row.mprice,
              price: row.price,
              num: row.num,
              joinCommission: 1, // 1 参与 2 不参与
              extendContent: row.extendContent,
            },
          });
        }
        if (arr.length === 0) {
          return;
        }
        let loading = this.$loading();
        this.$http.post("/api/Case/Goods/AddMany", arr).then((res) => {
          loading.close();
          if (res.code === 0) {
            this.$message({
              message: "粘贴成功",
              type: "success",
            });
            this.getIllnessCase();
          }
        });
      });
    },
    // 添加检测
    submit_dialogAddGoods1({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods1_state=false;
      if (goodsType === 4) {
        let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
        let table = this.staticInfo.inspectItem;
        for (let i = 0; i < table.length; i++) {
          if (this.$public.isNull(table[i].orderNum)) {
            if (table[i].goodsName == row.goodsName) {
              this.$message({
                message: "该服务已添加",
                type: "error",
              });
              return;
            }
          }
        }
        this.addGoodsApi(1, row);
      } else if (goodsType === 1) {
        let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
        let table = this.staticInfo.inspectItem;
        for (let i = 0; i < table.length; i++) {
          if (this.$public.isNull(table[i].orderNum)) {
            if (table[i].skus == row.skus && table[i].goodsId == row.goodsId) {
              this.$message({
                message: "该商品已添加",
                type: "error",
              });
              return;
            }
          }
        }
        if (row.stock == 0) {
          this.$message({
            message: "该商品已没有库存，请及时申请采购",
            type: "error",
          });
          return;
        }
        this.addGoodsApi(1, row);
      }
    },
    // 添加处置
    submit_dialogAddGoods3({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods3_state=false;
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.staticInfo.handleItem;
      for (let i = 0; i < table.length; i++) {
        if (this.$public.isNull(table[i].orderNum)) {
          if (table[i].goodsName == row.goodsName) {
            this.$message({
              message: "该服务已添加",
              type: "error",
            });
            return;
          }
        }
      }
      this.addGoodsApi(3, row);
    },
    // 添加手术
    submit_dialogAddGoods4({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods4_state=false;
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.staticInfo.operationItem;
      for (let i = 0; i < table.length; i++) {
        if (this.$public.isNull(table[i].orderNum)) {
          if (table[i].goodsName == row.goodsName) {
            this.$message({
              message: "该服务已添加",
              type: "error",
            });
            return;
          }
        }
      }
      this.addGoodsApi(4, row);
    },
    // 添加处方
    submit_dialogAddGoods2({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods2_state=false;
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.staticInfo.recipelItem || [];

      for (let i = 0; i < table.length; i++) {
        if (this.$public.isNull(table[i].orderNum)) {
          if (table[i].skus == row.skus && table[i].goodsId == row.goodsId) {
            this.$message({
              message: "该商品已添加",
              type: "error",
            });
            return;
          }
        }
      }
      if (row.stock == 0) {
        this.$message({
          message: "该商品已没有库存，请及时申请采购",
          type: "error",
        });
        return;
      }
      this.addGoodsApi(2, row);
    },
    // 添加并发症处方
    submit_dialogAddGoods6({ goodsItem, skuItem, wayItem, goodsType }) {
      // this.dialogAddGoods6_state=false;
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.staticInfo.complicationItem;
      for (let i = 0; i < table.length; i++) {
        if (this.$public.isNull(table[i].orderNum)) {
          if (table[i].skus == row.skus && table[i].goodsId == row.goodsId) {
            this.$message({
              message: "该商品已添加",
              type: "error",
            });
            return;
          }
        }
      }
      if (row.stock == 0) {
        this.$message({
          message: "该商品已没有库存，请及时申请采购",
          type: "error",
        });
        return;
      }
      this.addGoodsApi(6, row);
    },
    // 住院
    createZhuyuan() {
      this.changeIllnessCase("defaultSave");
      this.dialogAddZhuyuan_state = true;
      // if(this.staticInfo.caseNumber){
      // 	this.submit("createZhuyuan")
      // }else{
      // 	this.$confirm('当前病例未生成，添加住院前系统将自动创建病例。是否继续？', '警告', {
      // 		confirmButtonText: '确定',
      // 		cancelButtonText: '取消',
      // 		type: 'warning'
      // 	}).then(() => {
      // 		this.submit('createZhuyuan')
      // 	})
      // }
    },
    submit_addZhuyuan() {
      this.dialogAddZhuyuan_state = false;
      this.getIllnessCase();
    },
    // 编辑住院
    submit_editZhuyuan() {
      this.dialogEditZhuyuan_state = false;
      this.getIllnessCase();
    },
    getCurPetZhuyuanList(inHospitalId) {
      let params = {
        inHospitalId: inHospitalId,
      };
      this.$http.get("/api/InHospital/Detail", params).then((res) => {
        if (res.code == 0) {
          this.curPetZhuyuanList = [res.data];
        }
      });
    },
    // 过敏史
    submit_drawerAllergyList(obj) {
      this.drawerAllergyList_state = false;
      if (obj.type === "success") {
        this.drawerAllergyList_state = false;
      }
    },
    // 计算总计 1 2 3 4 5
    getTotal() {
      for (let type = 1; type < 7; type++) {
        let paid = 0;
        let total = 0;
        let vipTotal = 0;
        let table = [];
        let selectedArr = [];
        if (type === 1) {
          table = this.staticInfo.inspectItem;
          selectedArr = this.selectedArr1;
        } else if (type === 2) {
          table = this.staticInfo.recipelItem;
          selectedArr = this.selectedArr2;
        } else if (type === 6) {
          table = this.staticInfo.complicationItem;
          selectedArr = this.selectedArr6;
        } else if (type === 3) {
          table = this.staticInfo.handleItem;
          selectedArr = this.selectedArr3;
        } else if (type === 4) {
          table = this.staticInfo.operationItem;
          selectedArr = this.selectedArr4;
        } else if (type === 5) {
          table = this.staticInfo.inHospitalItem;
          selectedArr = this.selectedArr5;
        }
        for (let i = 0; i < table.length; i++) {
          if (selectedArr[i] === true) {
            // 选中
            // 总计
            if (
              table[i].allowWholesale === 1 ||
              this.$public.isNull(table[i].allowWholesale)
            ) {

              total = this.$public.jia(
                total,
                this.$public.cheng(table[i].price, table[i].num)
              );
              // if(this.userInfo.club_card.is_valid==true&&table[i].vipPrice>0){
              //   vipTotal = this.$public.jia(
              //   vipTotal,
              //   this.$public.cheng(table[i].vipPrice, table[i].num)
              // );
              // }else{
              //   vipTotal = this.$public.jia(
              //   vipTotal,
              //   this.$public.cheng(table[i].price, table[i].num)
              // );
              // }
              vipTotal = this.$public.jia(
                vipTotal,
                this.$public.cheng((table[i].vipPrice > 0 ? table[i].vipPrice : table[i].price), table[i].num)
              );


              if (table[i].isPay) {
                // 已支付
                paid = this.$public.jia(
                  paid,
                  this.$public.cheng(table[i].price, table[i].num)
                );
              }
            } else {
              total = this.$public.jia(
                total,
                this.$public.cheng(table[i].price, table[i].countPriceDosage)
              );
              vipTotal = this.$public.jia(
                vipTotal,
                this.$public.cheng((table[i].vipPrice > 0 ? table[i].vipPrice : table[i].price), table[i].countPriceDosage)
              );
              if (table[i].isPay) {
                // 已支付
                paid = this.$public.jia(
                  paid,
                  this.$public.cheng(table[i].price, table[i].countPriceDosage)
                );
              }
            }
          }
        }
        this["tableMoney" + type].vipTotal = vipTotal;
        this["tableMoney" + type].total = total;
        this["tableMoney" + type].paid = paid;
        this["tableMoney" + type].unpaid = this.$public.jian(total, paid);
      }
    },
    // 获取病例详情
    getIllnessCase(caseType) {
      //  caseType: changeUserInfo  mounted
      let params = {
        caseNumber:
          this.bingliParams.curRow.caseNumber ||
          this.bingliParams.curRow.recordId,
        str: Math.random(),
      };
      let loading = this.$loading();
      this.$http.get("/api/Case/Detail", params).then((res) => {
        loading.close();
        if (res.code == 0) {

          // // getGoodsInfo
          // this.$util
          //   .getGoodsInventory(res.data.recipelItem)
          //   .then((goodsList) => {
          //     // res.data.recipelItem = goodsList;
          //   });
          res.data.inspectItem = res.data.inspectItem || [];
          res.data.recipelItem = res.data.recipelItem || [];
          res.data.complicationItem = res.data.complicationItem || [];
          res.data.handleItem = res.data.handleItem || [];
          res.data.operationItem = res.data.operationItem || [];
          res.data.inHospitalItem = res.data.inHospitalItem || [];
          this.staticInfo = res.data;
          // this.dialogAddGoods2_state = true;
          // this.setTimeout(() => {
          //   this.dialogAddGoods2_state = false;
          // }, 500);
          this.bingliParams.curRow.caseNumber = res.data.caseNumber;
          this.$store.commit("yiliaoxin/set_bingliParams", this.bingliParams);
          this.bingliTab2Prop_diagnosisTags = this.staticInfo.diagnosisTags;
          if (caseType === "changeUserInfo") {
            this.getUserInfo(res.data.memberId);
            this.getHuifangHistory();
            this.getGuahaoDetail(); // 结束诊疗时使用
          }
          // 病情诊断 回访时间 复诊时间         需要单独处理
          this.visitTime = this.$public.isNull(this.staticInfo.visitDate)
            ? ""
            : new Date(this.staticInfo.visitDate * 1000);
          this.nextHuifangRadio = this.$public.isNull(this.staticInfo.visitDate)
            ? false
            : true;
          this.againSeeTime = this.$public.isNull(this.staticInfo.againSeeDate)
            ? ""
            : new Date(this.staticInfo.againSeeDate * 1000);
          // 症状
          let curTag = [];
          let tags = this.staticInfo.diagnosisTags;
          for (let i = 0; i < tags.length; i++) {
            for (let a = 0; a < tags[i].symptom.length; a++) {
              for (let b = 0; b < tags[i].symptom[a].symptomLevel.length; b++) {
                curTag.push([
                  tags[i].key,
                  tags[i].symptom[a].key,
                  tags[i].symptom[a].symptomLevel[b].key,
                ]);
              }
            }
          }
          this.curTag = curTag;
          this.curTag_old = this.curTag;
          // 并发症
          this.complicationRadio =
            this.staticInfo.complication.length > 0 ||
              this.staticInfo.complicationCause.length > 0
              ? true
              : false;
          let curTag_complication = [];
          tags = this.staticInfo.complication;
          for (let i = 0; i < tags.length; i++) {
            for (let a = 0; a < tags[i].symptom.length; a++) {
              for (let b = 0; b < tags[i].symptom[a].symptomLevel.length; b++) {
                curTag_complication.push([
                  tags[i].key,
                  tags[i].symptom[a].key,
                  tags[i].symptom[a].symptomLevel[b].key,
                ]);
              }
            }
          }
          this.curTag_complication = curTag_complication;
          this.curTag_complication_old = this.curTag_complication;
          // 并发症原因
          let curTag_complicationCause = [];
          tags = this.staticInfo.complicationCause;
          for (let i = 0; i < tags.length; i++) {
            for (let a = 0; a < tags[i].symptom.length; a++) {
              for (let b = 0; b < tags[i].symptom[a].symptomLevel.length; b++) {
                curTag_complicationCause.push([
                  tags[i].key,
                  tags[i].symptom[a].key,
                  tags[i].symptom[a].symptomLevel[b].key,
                ]);
              }
            }
          }
          this.curTag_complicationCause = curTag_complicationCause;
          this.curTag_complicationCause_old = this.curTag_complicationCause;

          this.form.departmentId = this.staticInfo.departmentId;
          this.form.animalHeat = this.staticInfo.animalHeat;
          this.form.weight = this.staticInfo.weight;
          this.form.breatheRate = this.staticInfo.breatheRate;
          this.form.heartRate = this.staticInfo.heartRate;
          this.form.mainContent = this.staticInfo.mainContent;
          this.form.clinecContent = this.staticInfo.clinecContent;
          this.form.analyzeContent = this.staticInfo.analyzeContent;
          this.form.diagnosis = this.staticInfo.diagnosis;
          this.form.conditionLevel = this.staticInfo.conditionLevel;
          this.form.cureContent = this.staticInfo.cureContent;
          this.form.doctorAdvice = this.staticInfo.doctorAdvice;
          this.form.remark = this.staticInfo.remark;
          this.form.filePath = this.staticInfo.filePath;
          this.form.visitDays = this.staticInfo.visitDays;
          this.form.againSeeDays = this.staticInfo.againSeeDays;
          this.form.againSeeNoticeType = this.staticInfo.againSeeNoticeType;
          this.form.contactName = this.staticInfo.contactName;
          this.form.contactMobile = this.staticInfo.contactMobile;
          this.form.completeState = this.staticInfo.completeState;
          this.form.diedCause = this.staticInfo.diedCause;
          this.form.diedRemark = this.staticInfo.diedRemark;

          // 初始化 selectedArr
          this.selectedArr1 = [];
          for (let i = 0; i < this.staticInfo.inspectItem.length; i++) {
            this.selectedArr1.push(true);
          }
          this.selectedArr2 = [];
          for (let i = 0; i < this.staticInfo.recipelItem.length; i++) {
            this.selectedArr2.push(true);
          }
          this.selectedArr6 = [];
          for (let i = 0; i < this.staticInfo.complicationItem.length; i++) {
            this.selectedArr6.push(true);
          }
          this.selectedArr3 = [];
          for (let i = 0; i < this.staticInfo.handleItem.length; i++) {
            this.selectedArr3.push(true);
          }
          this.selectedArr4 = [];
          for (let i = 0; i < this.staticInfo.operationItem.length; i++) {
            this.selectedArr4.push(true);
          }
          this.selectedArr5 = [];
          for (let i = 0; i < this.staticInfo.inHospitalItem.length; i++) {
            this.selectedArr5.push(true);
          }

          this.getTotal();

          // if(caseType==='mounted'){
          // 	this.getPayAddr()
          // }

          if (this.staticInfo.isCompleted == true) {
            return;
          } else {
            this.staticInfo.inHospitalId &&
              this.$public.isNull(this.curPetZhuyuanList) &&
              this.getCurPetZhuyuanList(this.staticInfo.inHospitalId);
          }

          // if(this.$route.query.type==='see'){
          // 	this.curNavDate = this.staticInfo.caseNumber;
          // 	return ;
          // }
          // this.$util.getGoodsInfo(d.recipelItem||[]).then(goodsList=>{
          // 	for(let i=0;i<goodsList.length;i++){
          // 		goodsList[i].allow_wholesale = goodsList[i].allowWholesale
          // 		this.$set(goodsList[i],'skuValueIndex',0)
          // 		goodsList[i].skuStocks = goodsList[i].skuStocks||[]
          // 		for(let a=0;a<goodsList[i].skuStocks.length;a++){
          // 			if(goodsList[i].skuValue==goodsList[i].skuStocks[a].skuValue){
          // 				this.$set(goodsList[i],'skuValueIndex',a)
          // 				this.$set(goodsList[i],'originalPrice', this.$public.getCFPrice(goodsList[i].allow_wholesale,goodsList[i].in_exchanage,goodsList[i].skuStocks[a].salePrice))
          // 				this.$set(goodsList[i],'skus',goodsList[i].skuStocks[a].skus)
          // 				this.$set(goodsList[i],'skuValue',goodsList[i].skuStocks[a].skuValue)
          // 				this.$set(goodsList[i],'goodsDosage',goodsList[i].goodsDosage)
          // 			}
          // 		}
          // 		if(goodsList[i].goodsTimes){
          // 			let l = this.getWeightUnit(goodsList[i].goodsTimes)
          // 			this.$set(goodsList[i],'lDay',l[0])
          // 			this.$set(goodsList[i],'lTimes',l[1])
          // 			this.$set(goodsList[i],'lWeight',l[2])
          // 			this.$set(goodsList[i],'lWeightUnit',l[3]||'mg')
          // 		}
          // 	}

          // 	this.form.table2 = goodsList; // 处方
          // 	this.$util.getGoodsInfo(d.inspectItem||[]).then(goodsList1=>{
          // 		for(let i=0;i<goodsList1.length;i++){
          // 			goodsList1[i].allow_wholesale = goodsList1[i].allowWholesale
          // 			this.$set(goodsList1[i],'skuValueIndex',0)
          // 			goodsList1[i].skuStocks = goodsList1[i].skuStocks||[]
          // 			for(let a=0;a<goodsList1[i].skuStocks.length;a++){
          // 				if(goodsList1[i].skuValue==goodsList1[i].skuStocks[a].skuValue){
          // 					this.$set(goodsList1[i],'skuValueIndex',a)
          // 					this.$set(goodsList1[i],'originalPrice',this.$public.getCFPrice(goodsList1[i].allow_wholesale,goodsList1[i].in_exchanage,goodsList1[i].skuStocks[a].salePrice))
          // 					this.$set(goodsList1[i],'skus',goodsList1[i].skuStocks[a].skus)
          // 					this.$set(goodsList1[i],'skuValue',goodsList1[i].skuStocks[a].skuValue)
          // 				}
          // 			}
          // 			if(goodsList1[i].goodsTimes){
          // 				let l = this.getWeightUnit(goodsList1[i].goodsTimes)
          // 				this.$set(goodsList1[i],'lDay',l[0])
          // 				this.$set(goodsList1[i],'lTimes',l[1])
          // 				this.$set(goodsList1[i],'lWeight',l[2])
          // 				this.$set(goodsList1[i],'lWeightUnit',l[3]||'mg')
          // 			}
          // 		}

          // 		this.form.table1 = goodsList1; // 检测
          // 		this.form.table3 = d.handleItem||[]; //  处置
          // 		this.form.table4 = d.operationItem||[]; // 手术
          // 		this.form.table5 = d.inHospitalItem||[]; // 住院
          // 		this.$nextTick(()=>{
          // 			if(str==='mounted'){
          // 				for(let a=1;a<6;a++){
          // 					for(let b=0;b<this.form['table'+a].length;b++){
          // 						this.$refs['table'+a].toggleRowSelection(this.form['table'+a][b],true)
          // 					}
          // 				}
          // 			}else{
          // 				for(let b=0;b<t1.length;b++){
          // 					for(let c=0;c<this.form.table1.length;c++){
          // 						if(t1[b].goodsName==this.form.table1[c].goodsName&&t1[b].skus==this.form.table1[c].skus){
          // 							this.$refs['table1'].toggleRowSelection(this.form.table1[c],true)
          // 						}
          // 					}
          // 				}
          // 				for(let b=0;b<t2.length;b++){
          // 					for(let c=0;c<this.form.table2.length;c++){
          // 						if(t2[b].goodsName==this.form.table2[c].goodsName&&t2[b].skus==this.form.table2[c].skus){
          // 							this.$refs['table2'].toggleRowSelection(this.form.table2[c],true)
          // 						}
          // 					}
          // 				}
          // 				for(let b=0;b<t3.length;b++){
          // 					for(let c=0;c<this.form.table3.length;c++){
          // 						if(t3[b].goodsName==this.form.table3[c].goodsName&&t3[b].skus==this.form.table3[c].skus){
          // 							this.$refs['table3'].toggleRowSelection(this.form.table3[c],true)
          // 						}
          // 					}
          // 				}
          // 				for(let b=0;b<t4.length;b++){
          // 					for(let c=0;c<this.form.table4.length;c++){
          // 						if(t4[b].goodsName==this.form.table4[c].goodsName&&t4[b].skus==this.form.table4[c].skus){
          // 							this.$refs['table4'].toggleRowSelection(this.form.table4[c],true)
          // 						}
          // 					}
          // 				}
          // 				for(let b=0;b<t5.length;b++){
          // 					for(let c=0;c<this.form.table5.length;c++){
          // 						if(t5[b].goodsName==this.form.table5[c].goodsName&&t5[b].skus==this.form.table5[c].skus){
          // 							this.$refs['table5'].toggleRowSelection(this.form.table5[c],true)
          // 						}
          // 					}
          // 				}
          // 			}
          // 			this.curNavDate = this.staticInfo.caseNumber;
          // 			this.formString = JSON.stringify(this.form);
          // 			if(str == 'createOrder'){
          // 				this.$nextTick(()=>{
          // 					this.createOrder()
          // 				})
          // 				return ;
          // 			}else if(str=='addToEditCreateZhuyuan'){ // 创建住院
          // 				this.dialogAddZhuyuan_state=true;
          // 				return ;
          // 			}else if(str=="createZhuyuan"){  // 创建住院
          // 				this.dialogAddZhuyuan_state=true;
          // 				return ;
          // 			}
          // 			this.getPayAddr(this.staticInfo.caseNumber);
          // 		})
          // 	})
          // })
        }
      });
    },
    // 未支付订单
    getPayAddr() {
      this.orderNumber = "";
      this.$http
        .get("/api/Order/GetServiceOrder", {
          serviceId: this.bingliParams.curRow.caseNumber,
        })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.orderNumber = res.data[0].orderNumber;
            }
          }
        });
    },
    submit_dialogQRCode() {
      this.dialogQRCode_state = false;
      this.getIllnessCase("changeUserInfo");
      this.$store.dispatch("yiliaoxin/get_NotMedicalCount");
    },
    openDialogQRCode() {
      this.$http
        .get("/api/Order/GetServiceOrder", {
          serviceId: this.staticInfo.caseNumber,
        })
        .then((res) => {
          if (res.code === 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getIllnessCase();
              return;
            } else {
              if (res.data[0].totalMoney === 0) {
                this.$message({
                  message: "待支付金额为0，请联系前台进行支付",
                  type: "error",
                });
              } else {
                this.yiliao_state = true;
                // this.$http.get('/api/Pay/GotoPay', {orderNum:this.orderNumber}).then(res1 => {
                // 	if (res1.code == 0) {
                // 		this.codeUrl = res1.data.codeUrl
                // 		this.dialogQRCode_state = true
                // 	}
                // })
                // this.$http.get('/api/Pay/ScanPayOrder', {orderNum:this.orderNumber}).then(res1 => {
                // 	if (res1.code == 0) {
                // 		this.codeUrl = res1.data.codeUrl
                // 		this.$http.get('/api/Pay/JL/ScanPayOrder', {orderNum:this.orderNumber}).then(res1 => {
                // 			if (res1.code == 0) {
                // 				this.codeUrl_jialian = res1.data.codeUrl
                // 				this.dialogPay_state=true;
                // 			}
                // 		})
                // 	}
                // })
              }
            }
          }
        });
    },
    closeOrder() {
      this.$http
        .get("/api/Order/GetServiceOrder", {
          serviceId: this.staticInfo.caseNumber,
        })
        .then((res) => {
          if (res.code === 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getIllnessCase();
              return;
            } else {
              this.$confirm("确定要取消已生成的订单?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$http
                  .get("/api/Order/ReceivedOrder", {
                    order_id: this.orderNumber,
                  })
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message({
                        message: "取消成功",
                        type: "success",
                      });
                      this.getIllnessCase();
                    }
                  });
              });
            }
          }
        });
    },
    // 回访
    addHuifang() {
      let params = {
        visitResultId: "61a5e3c7be7ea5806d839b6e",
        visitResultName: "已联系",
        content: this.huifangContent,
        caseNumber: this.staticInfo.caseNumber,
      };
      let loading = this.$loading();
      this.$http.get("/api/case/huifang", params).then((res) => {
        loading.close();
        if (res.code === 0) {
          this.huifangContent = "";
          this.$message({
            message: "添加回访成功",
            type: "success",
          });
          this.getHuifangHistory();
        }
      });
    },
    getHuifangHistory() {
      let params = {
        caseNumber: this.staticInfo.caseNumber,
      };
      this.$http.get("/api/case/reply/list", params).then((res) => {
        if (res.code === 0) {
          this.huifangHistoryList = res.data;
        }
      });
    },
    // 获取医疗标签
    getMedicineTag() {
      this.$http
        .get(process.env.VUE_APP_Url_baseData + "/api/tag/medicine/tree", {})
        .then((res) => {
          let tree = [];
          for (let i = 0; i < res.data.length; i++) {
            // if(i>2){
            // 	continue
            // }
            let l1 = {
              key: res.data[i].code,
              value: res.data[i].label,
              symptom: [],
            };
            for (let a = 0; a < res.data[i].children.length; a++) {
              l1.symptom.push({
                key: res.data[i].children[a].code,
                value: res.data[i].children[a].label,
                symptom: [],
              });
              for (
                let b = 0;
                b < res.data[i].children[a].children.length;
                b++
              ) {
                l1.symptom[a].symptom.push({
                  key: res.data[i].children[a].children[b].code,
                  value: res.data[i].children[a].children[b].label,
                });
              }
            }
            tree.push(l1);
          }
          this.tagTree = tree;
          let dictionary = {};
          for (let i = 0; i < tree.length; i++) {
            dictionary[tree[i].key] = tree[i].value;
            for (let a = 0; a < tree[i].symptom.length; a++) {
              dictionary[tree[i].symptom[a].key] = tree[i].symptom[a].value;
              for (let b = 0; b < tree[i].symptom[a].symptom.length; b++) {
                dictionary[tree[i].symptom[a].symptom[b].key] =
                  tree[i].symptom[a].symptom[b].value;
              }
            }
          }
          this.TagDictionary = dictionary;
        });
    },
    getMedicineTagForDialogAddProduct() {
      let diagnosisTags = [];
      let arr = this.dg(this.curTag, this.TagDictionary);
      for (let i = 0; i < arr.length; i++) {
        let item = {
          key: arr[i].key,
          value: arr[i].value,
          symptom: [],
        };
        for (let a = 0; a < arr[i].child.length; a++) {
          item.symptom.push({
            key: arr[i].child[a].key,
            value: arr[i].child[a].value,
            symptomLevel: [],
          });
          for (let b = 0; b < arr[i].child[a].child.length; b++) {
            item.symptom[a].symptomLevel.push({
              key: arr[i].child[a].child[b].key,
              value: arr[i].child[a].child[b].value,
            });
          }
        }
        diagnosisTags.push(item);
      }
      return diagnosisTags;
    },
    getMedicineTag1ForDialogAddProduct() {
      let diagnosisTags = [];
      let arr = this.dg(this.curTag_complication, this.TagDictionary);
      for (let i = 0; i < arr.length; i++) {
        let item = {
          key: arr[i].key,
          value: arr[i].value,
          symptom: [],
        };
        for (let a = 0; a < arr[i].child.length; a++) {
          item.symptom.push({
            key: arr[i].child[a].key,
            value: arr[i].child[a].value,
            symptomLevel: [],
          });
          for (let b = 0; b < arr[i].child[a].child.length; b++) {
            item.symptom[a].symptomLevel.push({
              key: arr[i].child[a].child[b].key,
              value: arr[i].child[a].child[b].value,
            });
          }
        }
        diagnosisTags.push(item);
      }
      return diagnosisTags;
    },
    getDepartmentList() {
      this.$http.get("/api/Registration/Department/List", {}).then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    getUserInfo(id) {
      let params = {
        id: id,
        random: Math.random(),
      };
      this.$http.get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", params).then((res) => {
        if (res.code == 0) {
          this.$store.commit("yiliaoxin/set_userInfo", res.data);
          this.$store.commit("yiliaoxin/set_curPetId", this.staticInfo.petId);
          this.$store.dispatch(
            "yiliaoxin/get_danganNumber",
            this.staticInfo.petId
          );
        }
      });
    },
    stopBingli() {
      this.$confirm("确定要结束诊疗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .get("/api/Registration/Complete", {
            recordId: this.staticInfo.registrationRecordId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "结束成功",
                type: "success",
              });
              this.getIllnessCase("changeUserInfo");
            }
          });
      });
    },
    getGuahaoDetail() {
      let params = {
        recordId: this.staticInfo.registrationRecordId,
      };
      this.$http.get("/api/Registration/Detail", params).then((res) => {
        if (res.code == 0) {
          this.guahaoDetail = res.data;
        }
      });
    },
    openWindiw(url) {
      window.open(url);
    },
    scrollToComplicationDom() {
      let pDomTop = this.$refs.bingliL.scrollTop;
      let cDomTop = this.$refs.complicationDom.offsetTop;
      let cha = pDomTop - cDomTop;
      let step = cha / 10;
      let interval = setInterval(() => {
        pDomTop = pDomTop - step;
        if (pDomTop < cDomTop - 140) {
          clearInterval(interval);
        } else {
          this.$refs.bingliL.scrollTop = pDomTop;
        }
      }, 1);
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;

  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;

    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;

      .titleL {
        width: 30%;
        font-size: 14px;
        font-weight: bold;
      }

      .titleR {
        width: 70%;
        text-align: right;

        .btnItem {
          display: inline-flex;
          margin-right: 30px;
          cursor: pointer;

          .btnImg {
            width: 40px;
            height: 40px;
            margin-right: 5px;
            margin-top: -5px;
          }

          .btnText {
            font-size: 14px;
            color: $fontColor;
            line-height: 31px;
          }
        }
      }
    }

    .content {
      display: flex;
      padding: 0;
      width: 100%;
      height: calc(100% - 47px);
      box-sizing: border-box;

      .L {
        width: calc(100% - 406px);
        border-right: 1px solid #f2f2f2;
        flex-shrink: 0;
        box-sizing: border-box;
        overflow: auto;
        padding: 0;

        &::-webkit-scrollbar {
          width: 0px;
          // height: 4px;
        }

        .box {
          padding: 22px 0;
          border-bottom: 1px solid #f2f2f2;

          .boxTit {
            padding: 0 15px 0 0;

            .boxTitL {
              font-size: 16px;
              color: $fontColor;
              margin-right: 10px;
              font-weight: bold;
              padding-left: 18px;
              border-left: 4px solid $mainColor;
              display: inline-block;
            }

            .boxTitR {
              display: inline-block;
              float: right;
            }
          }

          .boxCon {
            padding-top: 16px;

            .line {
              display: flex;
              padding: 16px 0 0 0;

              .label {
                font-size: 14px;
                color: $fontColor;
                width: 92px;
                text-align: right;
                margin-right: 18px;
                line-height: 32px;
              }

              .value {
                width: calc(100% - 132px);

                .label1 {
                  display: inline-block;
                  margin-right: 16px;
                  width: 50px;
                  text-align: right;
                  font-size: 14px;
                }

                .value1 {
                  width: calc(50% - 100px);
                  margin-bottom: 16px;
                }
              }

              &.huifangLine {
                position: relative;

                .huifang {
                  ::v-deep {
                    .el-textarea__inner {
                      padding-right: 75px;
                    }
                  }
                }

                .huifangBtn {
                  position: absolute;
                  top: 20px;
                  right: 26px;
                  border-radius: 3px;
                  width: 68px;
                  line-height: 66px;
                  background-color: #ffa60e;
                  text-align: center;
                  font-size: 14px;
                  color: $fontColor;
                  cursor: pointer;
                }

                .huifangHistory {
                  border: 1px solid #e4e7f8;
                  border-radius: 4px;
                  background-color: #f3f6ff;
                  padding: 0 24px;
                  margin-top: 16px;

                  .huifangHistoryRow {
                    display: flex;
                    border-top: 1px solid #e0e2f1;

                    .cell {
                      line-height: 18px;
                      padding: 15px 0;
                      font-size: 12px;
                      color: $fontColor;
                      flex-shrink: 0;
                    }

                    .cell1 {
                      line-height: 18px;
                      padding: 15px 0;
                      font-size: 12px;
                      color: $fontColor;
                      width: 100%;
                      word-break: break-all;
                    }
                  }
                }
              }
            }

            .tableMoneyLine {
              font-size: 14px;
              color: #73737b;
              display: flex;
              justify-content: space-between;
              padding: 20px 20px;
              box-sizing: border-box;

              .totalL {}

              .totalR {}
            }
          }
        }
      }

      .R {
        width: 406px;
        height: 100%;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 4px;
          // height: 4px;
        }

        .tabLine {
          display: flex;
          padding: 18px 16px 16px 16px;

          .tabItem {
            font-size: 14px;
            color: #98989f;
            margin-right: 32px;
            cursor: pointer;
            line-height: 16px;

            &.active {
              font-size: 16px;
              color: $fontColor;
              font-weight: bold;
            }
          }
        }

        .tabCon {
          height: calc(100% - 50px);
        }
      }
    }
  }

  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;

    .settlementL {
      width: 50%;
      line-height: 32px;
      font-size: 16px;
    }

    .settlementR {
      width: 50%;
      text-align: right;

      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>